// @ts-nocheck
// Generated from src/antlr/formula.g4 by ANTLR 4.13.2
// noinspection ES6UnusedImports,JSUnusedGlobalSymbols,JSUnusedLocalSymbols

import {
  ATN,
  ATNDeserializer,
  DecisionState,
  DFA,
  FailedPredicateException,
  RecognitionException,
  NoViableAltException,
  BailErrorStrategy,
  Parser,
  ParserATNSimulator,
  RuleContext,
  ParserRuleContext,
  PredictionMode,
  PredictionContextCache,
  TerminalNode,
  RuleNode,
  Token,
  TokenStream,
  Interval,
  IntervalSet,
} from 'antlr4'
import formulaListener from './formulaListener.js'
import formulaVisitor from './formulaVisitor.js'

// for running tests with parameters, TODO: discuss strategy for typed parameters in CI
// eslint-disable-next-line no-unused-vars
type int = number

import FormulaLexer from './formulaLexer.js'

export default class formulaParser extends Parser {
  public static readonly COLUMN_ID = 1
  public static readonly NUMBER = 2
  public static readonly STRING = 3
  public static readonly BOOLEAN = 4
  public static readonly WS = 5
  public static readonly AND = 6
  public static readonly OR = 7
  public static readonly NOT = 8
  public static readonly PLUS = 9
  public static readonly MINUS = 10
  public static readonly MULTIPLY = 11
  public static readonly DIVIDE = 12
  public static readonly LEFT_PAREN = 13
  public static readonly RIGHT_PAREN = 14
  public static readonly COMMA = 15
  public static readonly AND_OP = 16
  public static readonly OR_OP = 17
  public static readonly NOT_OP = 18
  public static readonly GT = 19
  public static readonly GTE = 20
  public static readonly LT = 21
  public static readonly LTE = 22
  public static readonly EQ = 23
  public static readonly NOT_EQ = 24
  public static readonly CONTAINS = 25
  public static readonly DOES_NOT_CONTAIN = 26
  public static readonly CONTAINS_ANY = 27
  public static readonly CONTAINS_ALL = 28
  public static readonly DOES_NOT_CONTAIN_ANY = 29
  public static readonly IS_EMPTY = 30
  public static readonly IS_NOT_EMPTY = 31
  public static readonly IN = 32
  public static readonly NOT_IN = 33
  public static readonly IFS = 34
  public static readonly SUMIF = 35
  public static readonly COUNTIF = 36
  public static readonly AVERAGEIF = 37
  public static readonly MAX = 38
  public static readonly MIN = 39
  public static readonly SUM = 40
  public static readonly COUNT = 41
  public static readonly COUNT_DISTINCT = 42
  public static readonly AVERAGE = 43
  public static readonly SUMPRODUCT = 44
  public static readonly CEIL = 45
  public static readonly FLOOR = 46
  public static readonly ROUND = 47
  public static readonly MAXIFS = 48
  public static readonly MINIFS = 49
  public static readonly UPPER = 50
  public static readonly LOWER = 51
  public static readonly TRIM = 52
  public static readonly LEN = 53
  public static readonly CONCAT = 54
  public static readonly LEFT = 55
  public static readonly RIGHT = 56
  public static readonly MID = 57
  public static readonly SUBSTITUTE = 58
  public static readonly DATE = 59
  public static readonly DATEADD = 60
  public static readonly DATEDIFF = 61
  public static readonly YEAR = 62
  public static readonly MONTH = 63
  public static readonly DAY = 64
  public static readonly TODAY = 65
  public static readonly NOW = 66
  public static readonly TO_TEXT = 67
  public static readonly TO_NUMBER = 68
  public static readonly TO_DATE = 69
  public static readonly TRUE = 70
  public static readonly FALSE = 71
  public static readonly INVALID_INPUT = 72
  public static override readonly EOF = Token.EOF
  public static readonly RULE_expr = 0
  public static readonly RULE_invalidInput = 1
  public static readonly RULE_formulaExpr = 2
  public static readonly RULE_sumExpr = 3
  public static readonly RULE_term = 4
  public static readonly RULE_factor = 5
  public static readonly RULE_functionCall = 6
  public static readonly RULE_singleArg = 7
  public static readonly RULE_multipleArgs = 8
  public static readonly RULE_twoArgs = 9
  public static readonly RULE_threeArgs = 10
  public static readonly RULE_ifArgs = 11
  public static readonly RULE_ifsArgs = 12
  public static readonly RULE_singleArgFunctionType = 13
  public static readonly RULE_multipleArgsFunctionType = 14
  public static readonly RULE_twoArgsFunctionType = 15
  public static readonly RULE_threeArgsFunctionType = 16
  public static readonly RULE_ifFunctionType = 17
  public static readonly RULE_logicExpr = 18
  public static readonly RULE_logicTerm = 19
  public static readonly RULE_notLogicExpr = 20
  public static readonly RULE_comparisonLogicExpr = 21
  public static readonly RULE_scalarRightContainsLogicExpr = 22
  public static readonly RULE_arrayRightContainsLogicExpr = 23
  public static readonly RULE_inLogicExpr = 24
  public static readonly RULE_unaryLogicExpr = 25
  public static readonly RULE_logicExprValue = 26
  public static readonly RULE_binarylogicOperator = 27
  public static readonly RULE_arrayRightContainsLogicOperator = 28
  public static readonly RULE_scalarRightContainsLogicOperator = 29
  public static readonly RULE_inLogicOperator = 30
  public static readonly RULE_unaryLogicOperator = 31
  public static readonly RULE_logicValue = 32
  public static readonly RULE_logicValueList = 33
  public static readonly RULE_numericListItem = 34
  public static readonly RULE_negativeNumericListItem = 35
  public static readonly RULE_stringListItem = 36
  public static readonly literalNames: (string | null)[] = [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    "'+'",
    "'-'",
    "'*'",
    "'/'",
    "'('",
    "')'",
    "','",
    "'&&'",
    "'||'",
    "'!'",
    "'>'",
    "'>='",
    "'<'",
    "'<='",
    "'='",
    "'!='",
  ]
  public static readonly symbolicNames: (string | null)[] = [
    null,
    'COLUMN_ID',
    'NUMBER',
    'STRING',
    'BOOLEAN',
    'WS',
    'AND',
    'OR',
    'NOT',
    'PLUS',
    'MINUS',
    'MULTIPLY',
    'DIVIDE',
    'LEFT_PAREN',
    'RIGHT_PAREN',
    'COMMA',
    'AND_OP',
    'OR_OP',
    'NOT_OP',
    'GT',
    'GTE',
    'LT',
    'LTE',
    'EQ',
    'NOT_EQ',
    'CONTAINS',
    'DOES_NOT_CONTAIN',
    'CONTAINS_ANY',
    'CONTAINS_ALL',
    'DOES_NOT_CONTAIN_ANY',
    'IS_EMPTY',
    'IS_NOT_EMPTY',
    'IN',
    'NOT_IN',
    'IFS',
    'SUMIF',
    'COUNTIF',
    'AVERAGEIF',
    'MAX',
    'MIN',
    'SUM',
    'COUNT',
    'COUNT_DISTINCT',
    'AVERAGE',
    'SUMPRODUCT',
    'CEIL',
    'FLOOR',
    'ROUND',
    'MAXIFS',
    'MINIFS',
    'UPPER',
    'LOWER',
    'TRIM',
    'LEN',
    'CONCAT',
    'LEFT',
    'RIGHT',
    'MID',
    'SUBSTITUTE',
    'DATE',
    'DATEADD',
    'DATEDIFF',
    'YEAR',
    'MONTH',
    'DAY',
    'TODAY',
    'NOW',
    'TO_TEXT',
    'TO_NUMBER',
    'TO_DATE',
    'TRUE',
    'FALSE',
    'INVALID_INPUT',
  ]
  // tslint:disable:no-trailing-whitespace
  public static readonly ruleNames: string[] = [
    'expr',
    'invalidInput',
    'formulaExpr',
    'sumExpr',
    'term',
    'factor',
    'functionCall',
    'singleArg',
    'multipleArgs',
    'twoArgs',
    'threeArgs',
    'ifArgs',
    'ifsArgs',
    'singleArgFunctionType',
    'multipleArgsFunctionType',
    'twoArgsFunctionType',
    'threeArgsFunctionType',
    'ifFunctionType',
    'logicExpr',
    'logicTerm',
    'notLogicExpr',
    'comparisonLogicExpr',
    'scalarRightContainsLogicExpr',
    'arrayRightContainsLogicExpr',
    'inLogicExpr',
    'unaryLogicExpr',
    'logicExprValue',
    'binarylogicOperator',
    'arrayRightContainsLogicOperator',
    'scalarRightContainsLogicOperator',
    'inLogicOperator',
    'unaryLogicOperator',
    'logicValue',
    'logicValueList',
    'numericListItem',
    'negativeNumericListItem',
    'stringListItem',
  ]
  public get grammarFileName(): string {
    return 'formula.g4'
  }
  public get literalNames(): (string | null)[] {
    return formulaParser.literalNames
  }
  public get symbolicNames(): (string | null)[] {
    return formulaParser.symbolicNames
  }
  public get ruleNames(): string[] {
    return formulaParser.ruleNames
  }
  public get serializedATN(): number[] {
    return formulaParser._serializedATN
  }

  protected createFailedPredicateException(
    predicate?: string,
    message?: string,
  ): FailedPredicateException {
    return new FailedPredicateException(this, predicate, message)
  }

  constructor(input: TokenStream) {
    super(input)
    this._interp = new ParserATNSimulator(
      this,
      formulaParser._ATN,
      formulaParser.DecisionsToDFA,
      new PredictionContextCache(),
    )
  }
  // @RuleVersion(0)
  public expr(): ExprContext {
    let localctx: ExprContext = new ExprContext(this, this._ctx, this.state)
    this.enterRule(localctx, 0, formulaParser.RULE_expr)
    let _la: number
    try {
      this.state = 84
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 1:
        case 2:
        case 3:
        case 10:
        case 13:
        case 34:
        case 35:
        case 36:
        case 37:
        case 38:
        case 39:
        case 40:
        case 41:
        case 42:
        case 43:
        case 44:
        case 45:
        case 46:
        case 47:
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
        case 58:
        case 59:
        case 60:
        case 61:
        case 62:
        case 63:
        case 64:
        case 65:
        case 66:
        case 67:
        case 68:
        case 69:
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 74
            this.formulaExpr()
            this.state = 75
            this.match(formulaParser.EOF)
          }
          break
        case -1:
        case 72:
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 80
            this._errHandler.sync(this)
            _la = this._input.LA(1)
            while (_la === 72) {
              {
                {
                  this.state = 77
                  this.invalidInput()
                }
              }
              this.state = 82
              this._errHandler.sync(this)
              _la = this._input.LA(1)
            }
            this.state = 83
            this.match(formulaParser.EOF)
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public invalidInput(): InvalidInputContext {
    let localctx: InvalidInputContext = new InvalidInputContext(this, this._ctx, this.state)
    this.enterRule(localctx, 2, formulaParser.RULE_invalidInput)
    try {
      let _alt: number
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 87
        this._errHandler.sync(this)
        _alt = 1
        do {
          switch (_alt) {
            case 1:
              {
                {
                  this.state = 86
                  this.match(formulaParser.INVALID_INPUT)
                }
              }
              break
            default:
              throw new NoViableAltException(this)
          }
          this.state = 89
          this._errHandler.sync(this)
          _alt = this._interp.adaptivePredict(this._input, 2, this._ctx)
        } while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER)

        // This block of code is executed when the 'invalid_input' rule matches
        // Retrieve all tokens that matched 'INVALID_INPUT'
        const errorTokens = localctx.getTokens(FormulaLexer.INVALID_INPUT)
        errorTokens.forEach((token) => {
          // Create a new RecognitionException with a message and context
          const error = new RecognitionException({
            message: 'Invalid input detected',
            recognizer: this,
            input: this._input,
            ctx: localctx,
          })
          // Set the offending token to the current 'INVALID_INPUT' token
          error.offendingToken = token.symbol
          // Notify the error listeners with the message, offending token, and error
          this.notifyErrorListeners('Invalid input detected', token.symbol, error)
        })
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public formulaExpr(): FormulaExprContext {
    let localctx: FormulaExprContext = new FormulaExprContext(this, this._ctx, this.state)
    this.enterRule(localctx, 4, formulaParser.RULE_formulaExpr)
    try {
      localctx = new SumExpressionContext(this, localctx)
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 93
        this.sumExpr(0)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }

  public sumExpr(): SumExprContext
  public sumExpr(_p: number): SumExprContext
  // @RuleVersion(0)
  public sumExpr(_p?: number): SumExprContext {
    if (_p === undefined) {
      _p = 0
    }

    let _parentctx: ParserRuleContext = this._ctx
    let _parentState: number = this.state
    let localctx: SumExprContext = new SumExprContext(this, this._ctx, _parentState)
    let _prevctx: SumExprContext = localctx
    let _startState: number = 6
    this.enterRecursionRule(localctx, 6, formulaParser.RULE_sumExpr, _p)
    try {
      let _alt: number
      this.enterOuterAlt(localctx, 1)
      {
        {
          localctx = new SingleTermContext(this, localctx)
          this._ctx = localctx
          _prevctx = localctx

          this.state = 96
          this.term(0)
        }
        this._ctx.stop = this._input.LT(-1)
        this.state = 106
        this._errHandler.sync(this)
        _alt = this._interp.adaptivePredict(this._input, 4, this._ctx)
        while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
          if (_alt === 1) {
            if (this._parseListeners != null) {
              this.triggerExitRuleEvent()
            }
            _prevctx = localctx
            {
              this.state = 104
              this._errHandler.sync(this)
              switch (this._interp.adaptivePredict(this._input, 3, this._ctx)) {
                case 1:
                  {
                    localctx = new AdditionExprContext(
                      this,
                      new SumExprContext(this, _parentctx, _parentState),
                    )
                    this.pushNewRecursionContext(localctx, _startState, formulaParser.RULE_sumExpr)
                    this.state = 98
                    if (!this.precpred(this._ctx, 3)) {
                      throw this.createFailedPredicateException('this.precpred(this._ctx, 3)')
                    }
                    this.state = 99
                    this.match(formulaParser.PLUS)
                    this.state = 100
                    this.term(0)
                  }
                  break
                case 2:
                  {
                    localctx = new SubtractionExprContext(
                      this,
                      new SumExprContext(this, _parentctx, _parentState),
                    )
                    this.pushNewRecursionContext(localctx, _startState, formulaParser.RULE_sumExpr)
                    this.state = 101
                    if (!this.precpred(this._ctx, 2)) {
                      throw this.createFailedPredicateException('this.precpred(this._ctx, 2)')
                    }
                    this.state = 102
                    this.match(formulaParser.MINUS)
                    this.state = 103
                    this.term(0)
                  }
                  break
              }
            }
          }
          this.state = 108
          this._errHandler.sync(this)
          _alt = this._interp.adaptivePredict(this._input, 4, this._ctx)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.unrollRecursionContexts(_parentctx)
    }
    return localctx
  }

  public term(): TermContext
  public term(_p: number): TermContext
  // @RuleVersion(0)
  public term(_p?: number): TermContext {
    if (_p === undefined) {
      _p = 0
    }

    let _parentctx: ParserRuleContext = this._ctx
    let _parentState: number = this.state
    let localctx: TermContext = new TermContext(this, this._ctx, _parentState)
    let _prevctx: TermContext = localctx
    let _startState: number = 8
    this.enterRecursionRule(localctx, 8, formulaParser.RULE_term, _p)
    try {
      let _alt: number
      this.enterOuterAlt(localctx, 1)
      {
        {
          localctx = new SingleFactorContext(this, localctx)
          this._ctx = localctx
          _prevctx = localctx

          this.state = 110
          this.factor()
        }
        this._ctx.stop = this._input.LT(-1)
        this.state = 120
        this._errHandler.sync(this)
        _alt = this._interp.adaptivePredict(this._input, 6, this._ctx)
        while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
          if (_alt === 1) {
            if (this._parseListeners != null) {
              this.triggerExitRuleEvent()
            }
            _prevctx = localctx
            {
              this.state = 118
              this._errHandler.sync(this)
              switch (this._interp.adaptivePredict(this._input, 5, this._ctx)) {
                case 1:
                  {
                    localctx = new MultiplicationExprContext(
                      this,
                      new TermContext(this, _parentctx, _parentState),
                    )
                    this.pushNewRecursionContext(localctx, _startState, formulaParser.RULE_term)
                    this.state = 112
                    if (!this.precpred(this._ctx, 3)) {
                      throw this.createFailedPredicateException('this.precpred(this._ctx, 3)')
                    }
                    this.state = 113
                    this.match(formulaParser.MULTIPLY)
                    this.state = 114
                    this.factor()
                  }
                  break
                case 2:
                  {
                    localctx = new DivisionExprContext(
                      this,
                      new TermContext(this, _parentctx, _parentState),
                    )
                    this.pushNewRecursionContext(localctx, _startState, formulaParser.RULE_term)
                    this.state = 115
                    if (!this.precpred(this._ctx, 2)) {
                      throw this.createFailedPredicateException('this.precpred(this._ctx, 2)')
                    }
                    this.state = 116
                    this.match(formulaParser.DIVIDE)
                    this.state = 117
                    this.factor()
                  }
                  break
              }
            }
          }
          this.state = 122
          this._errHandler.sync(this)
          _alt = this._interp.adaptivePredict(this._input, 6, this._ctx)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.unrollRecursionContexts(_parentctx)
    }
    return localctx
  }
  // @RuleVersion(0)
  public factor(): FactorContext {
    let localctx: FactorContext = new FactorContext(this, this._ctx, this.state)
    this.enterRule(localctx, 10, formulaParser.RULE_factor)
    try {
      this.state = 135
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 13:
          localctx = new NestedSumExprContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 123
            this.match(formulaParser.LEFT_PAREN)
            this.state = 124
            this.sumExpr(0)
            this.state = 125
            this.match(formulaParser.RIGHT_PAREN)
          }
          break
        case 34:
        case 35:
        case 36:
        case 37:
        case 38:
        case 39:
        case 40:
        case 41:
        case 42:
        case 43:
        case 44:
        case 45:
        case 46:
        case 47:
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
        case 58:
        case 59:
        case 60:
        case 61:
        case 62:
        case 63:
        case 64:
        case 67:
        case 68:
        case 69:
          localctx = new FunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 127
            this.functionCall()
          }
          break
        case 1:
          localctx = new ColumnRefContext(this, localctx)
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 128
            this.match(formulaParser.COLUMN_ID)
          }
          break
        case 2:
          localctx = new NumberContext(this, localctx)
          this.enterOuterAlt(localctx, 4)
          {
            this.state = 129
            this.match(formulaParser.NUMBER)
          }
          break
        case 10:
          localctx = new NegativeNumberContext(this, localctx)
          this.enterOuterAlt(localctx, 5)
          {
            this.state = 130
            this.match(formulaParser.MINUS)
            this.state = 131
            this.match(formulaParser.NUMBER)
          }
          break
        case 3:
          localctx = new StringLiteralContext(this, localctx)
          this.enterOuterAlt(localctx, 6)
          {
            this.state = 132
            this.match(formulaParser.STRING)
          }
          break
        case 65:
          localctx = new TodayLiteralContext(this, localctx)
          this.enterOuterAlt(localctx, 7)
          {
            this.state = 133
            this.match(formulaParser.TODAY)
          }
          break
        case 66:
          localctx = new NowLiteralContext(this, localctx)
          this.enterOuterAlt(localctx, 8)
          {
            this.state = 134
            this.match(formulaParser.NOW)
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public functionCall(): FunctionCallContext {
    let localctx: FunctionCallContext = new FunctionCallContext(this, this._ctx, this.state)
    this.enterRule(localctx, 12, formulaParser.RULE_functionCall)
    try {
      this.state = 167
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 40:
        case 41:
        case 42:
        case 45:
        case 46:
        case 50:
        case 51:
        case 52:
        case 53:
        case 62:
        case 63:
        case 64:
        case 67:
        case 68:
          localctx = new SingleArgumentFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 137
            this.singleArgFunctionType()
            this.state = 138
            this.match(formulaParser.LEFT_PAREN)
            this.state = 139
            this.singleArg()
            this.state = 140
            this.match(formulaParser.RIGHT_PAREN)
          }
          break
        case 38:
        case 39:
        case 43:
        case 44:
        case 47:
        case 54:
        case 69:
          localctx = new MultipleArgumentsFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 142
            this.multipleArgsFunctionType()
            this.state = 143
            this.match(formulaParser.LEFT_PAREN)
            this.state = 144
            this.multipleArgs()
            this.state = 145
            this.match(formulaParser.RIGHT_PAREN)
          }
          break
        case 55:
        case 56:
          localctx = new TwoArgumentsFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 147
            this.twoArgsFunctionType()
            this.state = 148
            this.match(formulaParser.LEFT_PAREN)
            this.state = 149
            this.twoArgs()
            this.state = 150
            this.match(formulaParser.RIGHT_PAREN)
          }
          break
        case 57:
        case 58:
        case 59:
        case 60:
        case 61:
          localctx = new ThreeArgumentsFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 4)
          {
            this.state = 152
            this.threeArgsFunctionType()
            this.state = 153
            this.match(formulaParser.LEFT_PAREN)
            this.state = 154
            this.threeArgs()
            this.state = 155
            this.match(formulaParser.RIGHT_PAREN)
          }
          break
        case 35:
        case 36:
        case 37:
        case 48:
        case 49:
          localctx = new IfFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 5)
          {
            this.state = 157
            this.ifFunctionType()
            this.state = 158
            this.match(formulaParser.LEFT_PAREN)
            this.state = 159
            this.ifArgs()
            this.state = 160
            this.match(formulaParser.RIGHT_PAREN)
          }
          break
        case 34:
          localctx = new IfsFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 6)
          {
            this.state = 162
            this.match(formulaParser.IFS)
            this.state = 163
            this.match(formulaParser.LEFT_PAREN)
            this.state = 164
            this.ifsArgs()
            this.state = 165
            this.match(formulaParser.RIGHT_PAREN)
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public singleArg(): SingleArgContext {
    let localctx: SingleArgContext = new SingleArgContext(this, this._ctx, this.state)
    this.enterRule(localctx, 14, formulaParser.RULE_singleArg)
    try {
      localctx = new SingleExpressionContext(this, localctx)
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 169
        this.formulaExpr()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public multipleArgs(): MultipleArgsContext {
    let localctx: MultipleArgsContext = new MultipleArgsContext(this, this._ctx, this.state)
    this.enterRule(localctx, 16, formulaParser.RULE_multipleArgs)
    let _la: number
    try {
      localctx = new MultipleExpressionsContext(this, localctx)
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 171
        this.singleArg()
        this.state = 176
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (_la === 15) {
          {
            {
              this.state = 172
              this.match(formulaParser.COMMA)
              this.state = 173
              this.singleArg()
            }
          }
          this.state = 178
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public twoArgs(): TwoArgsContext {
    let localctx: TwoArgsContext = new TwoArgsContext(this, this._ctx, this.state)
    this.enterRule(localctx, 18, formulaParser.RULE_twoArgs)
    try {
      localctx = new TwoExpressionArgsContext(this, localctx)
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 179
        this.singleArg()
        this.state = 180
        this.match(formulaParser.COMMA)
        this.state = 181
        this.singleArg()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public threeArgs(): ThreeArgsContext {
    let localctx: ThreeArgsContext = new ThreeArgsContext(this, this._ctx, this.state)
    this.enterRule(localctx, 20, formulaParser.RULE_threeArgs)
    try {
      localctx = new ThreeExpressionArgsContext(this, localctx)
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 183
        this.singleArg()
        this.state = 184
        this.match(formulaParser.COMMA)
        this.state = 185
        this.singleArg()
        this.state = 186
        this.match(formulaParser.COMMA)
        this.state = 187
        this.singleArg()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public ifArgs(): IfArgsContext {
    let localctx: IfArgsContext = new IfArgsContext(this, this._ctx, this.state)
    this.enterRule(localctx, 22, formulaParser.RULE_ifArgs)
    try {
      localctx = new TwoExpressionsContext(this, localctx)
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 189
        this.logicExpr(0)
        this.state = 190
        this.match(formulaParser.COMMA)
        this.state = 191
        this.formulaExpr()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public ifsArgs(): IfsArgsContext {
    let localctx: IfsArgsContext = new IfsArgsContext(this, this._ctx, this.state)
    this.enterRule(localctx, 24, formulaParser.RULE_ifsArgs)
    let _la: number
    try {
      localctx = new EvenExpressionsContext(this, localctx)
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 193
        this.ifArgs()
        this.state = 198
        this._errHandler.sync(this)
        _la = this._input.LA(1)
        while (_la === 15) {
          {
            {
              this.state = 194
              this.match(formulaParser.COMMA)
              this.state = 195
              this.ifArgs()
            }
          }
          this.state = 200
          this._errHandler.sync(this)
          _la = this._input.LA(1)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public singleArgFunctionType(): SingleArgFunctionTypeContext {
    let localctx: SingleArgFunctionTypeContext = new SingleArgFunctionTypeContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 26, formulaParser.RULE_singleArgFunctionType)
    try {
      this.state = 215
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 40:
          localctx = new SumFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 201
            this.match(formulaParser.SUM)
          }
          break
        case 41:
          localctx = new CountFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 202
            this.match(formulaParser.COUNT)
          }
          break
        case 42:
          localctx = new CountDistinctFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 203
            this.match(formulaParser.COUNT_DISTINCT)
          }
          break
        case 45:
          localctx = new CeilFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 4)
          {
            this.state = 204
            this.match(formulaParser.CEIL)
          }
          break
        case 46:
          localctx = new FloorFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 5)
          {
            this.state = 205
            this.match(formulaParser.FLOOR)
          }
          break
        case 50:
          localctx = new UpperFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 6)
          {
            this.state = 206
            this.match(formulaParser.UPPER)
          }
          break
        case 51:
          localctx = new LowerFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 7)
          {
            this.state = 207
            this.match(formulaParser.LOWER)
          }
          break
        case 52:
          localctx = new TrimFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 8)
          {
            this.state = 208
            this.match(formulaParser.TRIM)
          }
          break
        case 53:
          localctx = new LenFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 9)
          {
            this.state = 209
            this.match(formulaParser.LEN)
          }
          break
        case 62:
          localctx = new YearFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 10)
          {
            this.state = 210
            this.match(formulaParser.YEAR)
          }
          break
        case 63:
          localctx = new MonthFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 11)
          {
            this.state = 211
            this.match(formulaParser.MONTH)
          }
          break
        case 64:
          localctx = new DayFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 12)
          {
            this.state = 212
            this.match(formulaParser.DAY)
          }
          break
        case 67:
          localctx = new ToTextFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 13)
          {
            this.state = 213
            this.match(formulaParser.TO_TEXT)
          }
          break
        case 68:
          localctx = new ToNumberFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 14)
          {
            this.state = 214
            this.match(formulaParser.TO_NUMBER)
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public multipleArgsFunctionType(): MultipleArgsFunctionTypeContext {
    let localctx: MultipleArgsFunctionTypeContext = new MultipleArgsFunctionTypeContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 28, formulaParser.RULE_multipleArgsFunctionType)
    try {
      this.state = 224
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 38:
          localctx = new MaxFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 217
            this.match(formulaParser.MAX)
          }
          break
        case 39:
          localctx = new MinFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 218
            this.match(formulaParser.MIN)
          }
          break
        case 43:
          localctx = new AverageFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 219
            this.match(formulaParser.AVERAGE)
          }
          break
        case 44:
          localctx = new SumProductFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 4)
          {
            this.state = 220
            this.match(formulaParser.SUMPRODUCT)
          }
          break
        case 54:
          localctx = new ConcatFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 5)
          {
            this.state = 221
            this.match(formulaParser.CONCAT)
          }
          break
        case 47:
          localctx = new RoundFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 6)
          {
            this.state = 222
            this.match(formulaParser.ROUND)
          }
          break
        case 69:
          localctx = new ToDateFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 7)
          {
            this.state = 223
            this.match(formulaParser.TO_DATE)
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public twoArgsFunctionType(): TwoArgsFunctionTypeContext {
    let localctx: TwoArgsFunctionTypeContext = new TwoArgsFunctionTypeContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 30, formulaParser.RULE_twoArgsFunctionType)
    try {
      this.state = 228
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 55:
          localctx = new LeftFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 226
            this.match(formulaParser.LEFT)
          }
          break
        case 56:
          localctx = new RightFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 227
            this.match(formulaParser.RIGHT)
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public threeArgsFunctionType(): ThreeArgsFunctionTypeContext {
    let localctx: ThreeArgsFunctionTypeContext = new ThreeArgsFunctionTypeContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 32, formulaParser.RULE_threeArgsFunctionType)
    try {
      this.state = 235
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 58:
          localctx = new SubstituteFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 230
            this.match(formulaParser.SUBSTITUTE)
          }
          break
        case 57:
          localctx = new MidFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 231
            this.match(formulaParser.MID)
          }
          break
        case 59:
          localctx = new DateFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 232
            this.match(formulaParser.DATE)
          }
          break
        case 60:
          localctx = new DateaddFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 4)
          {
            this.state = 233
            this.match(formulaParser.DATEADD)
          }
          break
        case 61:
          localctx = new DatediffFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 5)
          {
            this.state = 234
            this.match(formulaParser.DATEDIFF)
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public ifFunctionType(): IfFunctionTypeContext {
    let localctx: IfFunctionTypeContext = new IfFunctionTypeContext(this, this._ctx, this.state)
    this.enterRule(localctx, 34, formulaParser.RULE_ifFunctionType)
    try {
      this.state = 242
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 35:
          localctx = new SumIfFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 237
            this.match(formulaParser.SUMIF)
          }
          break
        case 36:
          localctx = new CountIfFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 238
            this.match(formulaParser.COUNTIF)
          }
          break
        case 37:
          localctx = new AverageIfFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 239
            this.match(formulaParser.AVERAGEIF)
          }
          break
        case 49:
          localctx = new MinIfsFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 4)
          {
            this.state = 240
            this.match(formulaParser.MINIFS)
          }
          break
        case 48:
          localctx = new MaxIfsFunctionContext(this, localctx)
          this.enterOuterAlt(localctx, 5)
          {
            this.state = 241
            this.match(formulaParser.MAXIFS)
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }

  public logicExpr(): LogicExprContext
  public logicExpr(_p: number): LogicExprContext
  // @RuleVersion(0)
  public logicExpr(_p?: number): LogicExprContext {
    if (_p === undefined) {
      _p = 0
    }

    let _parentctx: ParserRuleContext = this._ctx
    let _parentState: number = this.state
    let localctx: LogicExprContext = new LogicExprContext(this, this._ctx, _parentState)
    let _prevctx: LogicExprContext = localctx
    let _startState: number = 36
    this.enterRecursionRule(localctx, 36, formulaParser.RULE_logicExpr, _p)
    try {
      let _alt: number
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 250
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 16, this._ctx)) {
          case 1:
            {
              localctx = new ParenthesizedLogicExprContext(this, localctx)
              this._ctx = localctx
              _prevctx = localctx

              this.state = 245
              this.match(formulaParser.LEFT_PAREN)
              this.state = 246
              this.logicExpr(0)
              this.state = 247
              this.match(formulaParser.RIGHT_PAREN)
            }
            break
          case 2:
            {
              localctx = new SingleLogicExprContext(this, localctx)
              this._ctx = localctx
              _prevctx = localctx
              this.state = 249
              this.logicTerm()
            }
            break
        }
        this._ctx.stop = this._input.LT(-1)
        this.state = 266
        this._errHandler.sync(this)
        _alt = this._interp.adaptivePredict(this._input, 18, this._ctx)
        while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
          if (_alt === 1) {
            if (this._parseListeners != null) {
              this.triggerExitRuleEvent()
            }
            _prevctx = localctx
            {
              this.state = 264
              this._errHandler.sync(this)
              switch (this._interp.adaptivePredict(this._input, 17, this._ctx)) {
                case 1:
                  {
                    localctx = new AndChainedLogicExprContext(
                      this,
                      new LogicExprContext(this, _parentctx, _parentState),
                    )
                    this.pushNewRecursionContext(
                      localctx,
                      _startState,
                      formulaParser.RULE_logicExpr,
                    )
                    this.state = 252
                    if (!this.precpred(this._ctx, 5)) {
                      throw this.createFailedPredicateException('this.precpred(this._ctx, 5)')
                    }
                    this.state = 253
                    this.match(formulaParser.AND)
                    this.state = 254
                    this.logicExpr(6)
                  }
                  break
                case 2:
                  {
                    localctx = new AndChainedLogicExprContext(
                      this,
                      new LogicExprContext(this, _parentctx, _parentState),
                    )
                    this.pushNewRecursionContext(
                      localctx,
                      _startState,
                      formulaParser.RULE_logicExpr,
                    )
                    this.state = 255
                    if (!this.precpred(this._ctx, 4)) {
                      throw this.createFailedPredicateException('this.precpred(this._ctx, 4)')
                    }
                    this.state = 256
                    this.match(formulaParser.AND_OP)
                    this.state = 257
                    this.logicExpr(5)
                  }
                  break
                case 3:
                  {
                    localctx = new OrChainedLogicExprContext(
                      this,
                      new LogicExprContext(this, _parentctx, _parentState),
                    )
                    this.pushNewRecursionContext(
                      localctx,
                      _startState,
                      formulaParser.RULE_logicExpr,
                    )
                    this.state = 258
                    if (!this.precpred(this._ctx, 3)) {
                      throw this.createFailedPredicateException('this.precpred(this._ctx, 3)')
                    }
                    this.state = 259
                    this.match(formulaParser.OR)
                    this.state = 260
                    this.logicExpr(4)
                  }
                  break
                case 4:
                  {
                    localctx = new OrChainedLogicExprContext(
                      this,
                      new LogicExprContext(this, _parentctx, _parentState),
                    )
                    this.pushNewRecursionContext(
                      localctx,
                      _startState,
                      formulaParser.RULE_logicExpr,
                    )
                    this.state = 261
                    if (!this.precpred(this._ctx, 2)) {
                      throw this.createFailedPredicateException('this.precpred(this._ctx, 2)')
                    }
                    this.state = 262
                    this.match(formulaParser.OR_OP)
                    this.state = 263
                    this.logicExpr(3)
                  }
                  break
              }
            }
          }
          this.state = 268
          this._errHandler.sync(this)
          _alt = this._interp.adaptivePredict(this._input, 18, this._ctx)
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.unrollRecursionContexts(_parentctx)
    }
    return localctx
  }
  // @RuleVersion(0)
  public logicTerm(): LogicTermContext {
    let localctx: LogicTermContext = new LogicTermContext(this, this._ctx, this.state)
    this.enterRule(localctx, 38, formulaParser.RULE_logicTerm)
    try {
      this.state = 280
      this._errHandler.sync(this)
      switch (this._interp.adaptivePredict(this._input, 19, this._ctx)) {
        case 1:
          localctx = new ParenthesizedLogicTermContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 269
            this.match(formulaParser.LEFT_PAREN)
            this.state = 270
            this.logicTerm()
            this.state = 271
            this.match(formulaParser.RIGHT_PAREN)
          }
          break
        case 2:
          localctx = new NotExpressionContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 273
            this.notLogicExpr()
          }
          break
        case 3:
          localctx = new BooleanExpressionContext(this, localctx)
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 274
            this.match(formulaParser.BOOLEAN)
          }
          break
        case 4:
          localctx = new ComparisonExpressionContext(this, localctx)
          this.enterOuterAlt(localctx, 4)
          {
            this.state = 275
            this.comparisonLogicExpr()
          }
          break
        case 5:
          localctx = new ScalarRightContainsExpressionContext(this, localctx)
          this.enterOuterAlt(localctx, 5)
          {
            this.state = 276
            this.scalarRightContainsLogicExpr()
          }
          break
        case 6:
          localctx = new ArrayRightContainsExpressionContext(this, localctx)
          this.enterOuterAlt(localctx, 6)
          {
            this.state = 277
            this.arrayRightContainsLogicExpr()
          }
          break
        case 7:
          localctx = new UnaryExpressionContext(this, localctx)
          this.enterOuterAlt(localctx, 7)
          {
            this.state = 278
            this.unaryLogicExpr()
          }
          break
        case 8:
          localctx = new InExpressionContext(this, localctx)
          this.enterOuterAlt(localctx, 8)
          {
            this.state = 279
            this.inLogicExpr()
          }
          break
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public notLogicExpr(): NotLogicExprContext {
    let localctx: NotLogicExprContext = new NotLogicExprContext(this, this._ctx, this.state)
    this.enterRule(localctx, 40, formulaParser.RULE_notLogicExpr)
    let _la: number
    try {
      localctx = new NotExprContext(this, localctx)
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 282
        _la = this._input.LA(1)
        if (!(_la === 8 || _la === 18)) {
          this._errHandler.recoverInline(this)
        } else {
          this._errHandler.reportMatch(this)
          this.consume()
        }
        this.state = 283
        this.match(formulaParser.LEFT_PAREN)
        this.state = 284
        this.logicExpr(0)
        this.state = 285
        this.match(formulaParser.RIGHT_PAREN)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public comparisonLogicExpr(): ComparisonLogicExprContext {
    let localctx: ComparisonLogicExprContext = new ComparisonLogicExprContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 42, formulaParser.RULE_comparisonLogicExpr)
    try {
      localctx = new BinaryLogicExprContext(this, localctx)
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 289
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 20, this._ctx)) {
          case 1:
            {
              this.state = 287
              this.logicValueList()
            }
            break
          case 2:
            {
              this.state = 288
              this.logicExprValue()
            }
            break
        }
        this.state = 291
        this.binarylogicOperator()
        this.state = 294
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 21, this._ctx)) {
          case 1:
            {
              this.state = 292
              this.logicValueList()
            }
            break
          case 2:
            {
              this.state = 293
              this.logicExprValue()
            }
            break
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public scalarRightContainsLogicExpr(): ScalarRightContainsLogicExprContext {
    let localctx: ScalarRightContainsLogicExprContext = new ScalarRightContainsLogicExprContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 44, formulaParser.RULE_scalarRightContainsLogicExpr)
    try {
      localctx = new ScalarRightContainsExprContext(this, localctx)
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 298
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 22, this._ctx)) {
          case 1:
            {
              this.state = 296
              this.logicValueList()
            }
            break
          case 2:
            {
              this.state = 297
              this.logicExprValue()
            }
            break
        }
        this.state = 300
        this.scalarRightContainsLogicOperator()
        this.state = 301
        this.logicExprValue()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public arrayRightContainsLogicExpr(): ArrayRightContainsLogicExprContext {
    let localctx: ArrayRightContainsLogicExprContext = new ArrayRightContainsLogicExprContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 46, formulaParser.RULE_arrayRightContainsLogicExpr)
    try {
      localctx = new ArrayRightContainsExprContext(this, localctx)
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 305
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 23, this._ctx)) {
          case 1:
            {
              this.state = 303
              this.logicValueList()
            }
            break
          case 2:
            {
              this.state = 304
              this.logicExprValue()
            }
            break
        }
        this.state = 307
        this.arrayRightContainsLogicOperator()
        this.state = 310
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 24, this._ctx)) {
          case 1:
            {
              this.state = 308
              this.logicValueList()
            }
            break
          case 2:
            {
              this.state = 309
              this.logicExprValue()
            }
            break
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public inLogicExpr(): InLogicExprContext {
    let localctx: InLogicExprContext = new InLogicExprContext(this, this._ctx, this.state)
    this.enterRule(localctx, 48, formulaParser.RULE_inLogicExpr)
    try {
      localctx = new InExprContext(this, localctx)
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 312
        this.logicExprValue()
        this.state = 313
        this.inLogicOperator()
        this.state = 316
        this._errHandler.sync(this)
        switch (this._interp.adaptivePredict(this._input, 25, this._ctx)) {
          case 1:
            {
              this.state = 314
              this.logicValueList()
            }
            break
          case 2:
            {
              this.state = 315
              this.logicExprValue()
            }
            break
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public unaryLogicExpr(): UnaryLogicExprContext {
    let localctx: UnaryLogicExprContext = new UnaryLogicExprContext(this, this._ctx, this.state)
    this.enterRule(localctx, 50, formulaParser.RULE_unaryLogicExpr)
    try {
      localctx = new UnaryExprContext(this, localctx)
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 318
        this.logicExprValue()
        this.state = 319
        this.unaryLogicOperator()
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public logicExprValue(): LogicExprValueContext {
    let localctx: LogicExprValueContext = new LogicExprValueContext(this, this._ctx, this.state)
    this.enterRule(localctx, 52, formulaParser.RULE_logicExprValue)
    try {
      this.state = 324
      this._errHandler.sync(this)
      switch (this._interp.adaptivePredict(this._input, 26, this._ctx)) {
        case 1:
          localctx = new LogicExprColumnRefContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 321
            this.match(formulaParser.COLUMN_ID)
          }
          break
        case 2:
          localctx = new FormulaInLogicContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 322
            this.formulaExpr()
          }
          break
        case 3:
          localctx = new DirectValueContext(this, localctx)
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 323
            this.logicValue()
          }
          break
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public binarylogicOperator(): BinarylogicOperatorContext {
    let localctx: BinarylogicOperatorContext = new BinarylogicOperatorContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 54, formulaParser.RULE_binarylogicOperator)
    try {
      this.state = 332
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 19:
          localctx = new GreaterThanContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 326
            this.match(formulaParser.GT)
          }
          break
        case 20:
          localctx = new GreaterThanOrEqualContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 327
            this.match(formulaParser.GTE)
          }
          break
        case 21:
          localctx = new LessThanContext(this, localctx)
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 328
            this.match(formulaParser.LT)
          }
          break
        case 22:
          localctx = new LessThanOrEqualContext(this, localctx)
          this.enterOuterAlt(localctx, 4)
          {
            this.state = 329
            this.match(formulaParser.LTE)
          }
          break
        case 23:
          localctx = new EqualContext(this, localctx)
          this.enterOuterAlt(localctx, 5)
          {
            this.state = 330
            this.match(formulaParser.EQ)
          }
          break
        case 24:
          localctx = new NotEqualContext(this, localctx)
          this.enterOuterAlt(localctx, 6)
          {
            this.state = 331
            this.match(formulaParser.NOT_EQ)
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public arrayRightContainsLogicOperator(): ArrayRightContainsLogicOperatorContext {
    let localctx: ArrayRightContainsLogicOperatorContext =
      new ArrayRightContainsLogicOperatorContext(this, this._ctx, this.state)
    this.enterRule(localctx, 56, formulaParser.RULE_arrayRightContainsLogicOperator)
    try {
      this.state = 337
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 27:
          localctx = new ContainsAnyContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 334
            this.match(formulaParser.CONTAINS_ANY)
          }
          break
        case 28:
          localctx = new ContainsAllContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 335
            this.match(formulaParser.CONTAINS_ALL)
          }
          break
        case 29:
          localctx = new DoesNotContainAnyContext(this, localctx)
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 336
            this.match(formulaParser.DOES_NOT_CONTAIN_ANY)
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public scalarRightContainsLogicOperator(): ScalarRightContainsLogicOperatorContext {
    let localctx: ScalarRightContainsLogicOperatorContext =
      new ScalarRightContainsLogicOperatorContext(this, this._ctx, this.state)
    this.enterRule(localctx, 58, formulaParser.RULE_scalarRightContainsLogicOperator)
    try {
      this.state = 341
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 25:
          localctx = new ContainsContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 339
            this.match(formulaParser.CONTAINS)
          }
          break
        case 26:
          localctx = new DoesNotContainContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 340
            this.match(formulaParser.DOES_NOT_CONTAIN)
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public inLogicOperator(): InLogicOperatorContext {
    let localctx: InLogicOperatorContext = new InLogicOperatorContext(this, this._ctx, this.state)
    this.enterRule(localctx, 60, formulaParser.RULE_inLogicOperator)
    try {
      this.state = 345
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 32:
          localctx = new InContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 343
            this.match(formulaParser.IN)
          }
          break
        case 33:
          localctx = new NotInContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 344
            this.match(formulaParser.NOT_IN)
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public unaryLogicOperator(): UnaryLogicOperatorContext {
    let localctx: UnaryLogicOperatorContext = new UnaryLogicOperatorContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 62, formulaParser.RULE_unaryLogicOperator)
    try {
      this.state = 349
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 30:
          localctx = new IsEmptyContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 347
            this.match(formulaParser.IS_EMPTY)
          }
          break
        case 31:
          localctx = new IsNotEmptyContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 348
            this.match(formulaParser.IS_NOT_EMPTY)
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public logicValue(): LogicValueContext {
    let localctx: LogicValueContext = new LogicValueContext(this, this._ctx, this.state)
    this.enterRule(localctx, 64, formulaParser.RULE_logicValue)
    try {
      this.state = 356
      this._errHandler.sync(this)
      switch (this._input.LA(1)) {
        case 2:
          localctx = new NumericValueContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 351
            this.match(formulaParser.NUMBER)
          }
          break
        case 10:
          localctx = new NegativeNumericValueContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 352
            this.match(formulaParser.MINUS)
            this.state = 353
            this.match(formulaParser.NUMBER)
          }
          break
        case 3:
          localctx = new StringValueContext(this, localctx)
          this.enterOuterAlt(localctx, 3)
          {
            this.state = 354
            this.match(formulaParser.STRING)
          }
          break
        case 4:
          localctx = new BooleanValueContext(this, localctx)
          this.enterOuterAlt(localctx, 4)
          {
            this.state = 355
            this.match(formulaParser.BOOLEAN)
          }
          break
        default:
          throw new NoViableAltException(this)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public logicValueList(): LogicValueListContext {
    let localctx: LogicValueListContext = new LogicValueListContext(this, this._ctx, this.state)
    this.enterRule(localctx, 66, formulaParser.RULE_logicValueList)
    let _la: number
    try {
      this.state = 386
      this._errHandler.sync(this)
      switch (this._interp.adaptivePredict(this._input, 37, this._ctx)) {
        case 1:
          localctx = new NumericValueListContext(this, localctx)
          this.enterOuterAlt(localctx, 1)
          {
            this.state = 358
            this.match(formulaParser.LEFT_PAREN)
            this.state = 361
            this._errHandler.sync(this)
            switch (this._input.LA(1)) {
              case 2:
                {
                  this.state = 359
                  this.numericListItem()
                }
                break
              case 10:
                {
                  this.state = 360
                  this.negativeNumericListItem()
                }
                break
              default:
                throw new NoViableAltException(this)
            }
            this.state = 370
            this._errHandler.sync(this)
            _la = this._input.LA(1)
            while (_la === 15) {
              {
                {
                  this.state = 363
                  this.match(formulaParser.COMMA)
                  this.state = 366
                  this._errHandler.sync(this)
                  switch (this._input.LA(1)) {
                    case 2:
                      {
                        this.state = 364
                        this.numericListItem()
                      }
                      break
                    case 10:
                      {
                        this.state = 365
                        this.negativeNumericListItem()
                      }
                      break
                    default:
                      throw new NoViableAltException(this)
                  }
                }
              }
              this.state = 372
              this._errHandler.sync(this)
              _la = this._input.LA(1)
            }
            this.state = 373
            this.match(formulaParser.RIGHT_PAREN)
          }
          break
        case 2:
          localctx = new StringValueListContext(this, localctx)
          this.enterOuterAlt(localctx, 2)
          {
            this.state = 375
            this.match(formulaParser.LEFT_PAREN)
            this.state = 376
            this.stringListItem()
            this.state = 381
            this._errHandler.sync(this)
            _la = this._input.LA(1)
            while (_la === 15) {
              {
                {
                  this.state = 377
                  this.match(formulaParser.COMMA)
                  this.state = 378
                  this.stringListItem()
                }
              }
              this.state = 383
              this._errHandler.sync(this)
              _la = this._input.LA(1)
            }
            this.state = 384
            this.match(formulaParser.RIGHT_PAREN)
          }
          break
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public numericListItem(): NumericListItemContext {
    let localctx: NumericListItemContext = new NumericListItemContext(this, this._ctx, this.state)
    this.enterRule(localctx, 68, formulaParser.RULE_numericListItem)
    try {
      localctx = new NumericItemContext(this, localctx)
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 388
        this.match(formulaParser.NUMBER)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public negativeNumericListItem(): NegativeNumericListItemContext {
    let localctx: NegativeNumericListItemContext = new NegativeNumericListItemContext(
      this,
      this._ctx,
      this.state,
    )
    this.enterRule(localctx, 70, formulaParser.RULE_negativeNumericListItem)
    try {
      localctx = new NegativeNumericItemContext(this, localctx)
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 390
        this.match(formulaParser.MINUS)
        this.state = 391
        this.match(formulaParser.NUMBER)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }
  // @RuleVersion(0)
  public stringListItem(): StringListItemContext {
    let localctx: StringListItemContext = new StringListItemContext(this, this._ctx, this.state)
    this.enterRule(localctx, 72, formulaParser.RULE_stringListItem)
    try {
      localctx = new StringItemContext(this, localctx)
      this.enterOuterAlt(localctx, 1)
      {
        this.state = 393
        this.match(formulaParser.STRING)
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        localctx.exception = re
        this._errHandler.reportError(this, re)
        this._errHandler.recover(this, re)
      } else {
        throw re
      }
    } finally {
      this.exitRule()
    }
    return localctx
  }

  public sempred(localctx: RuleContext, ruleIndex: number, predIndex: number): boolean {
    switch (ruleIndex) {
      case 3:
        return this.sumExpr_sempred(localctx as SumExprContext, predIndex)
      case 4:
        return this.term_sempred(localctx as TermContext, predIndex)
      case 18:
        return this.logicExpr_sempred(localctx as LogicExprContext, predIndex)
    }
    return true
  }
  private sumExpr_sempred(localctx: SumExprContext, predIndex: number): boolean {
    switch (predIndex) {
      case 0:
        return this.precpred(this._ctx, 3)
      case 1:
        return this.precpred(this._ctx, 2)
    }
    return true
  }
  private term_sempred(localctx: TermContext, predIndex: number): boolean {
    switch (predIndex) {
      case 2:
        return this.precpred(this._ctx, 3)
      case 3:
        return this.precpred(this._ctx, 2)
    }
    return true
  }
  private logicExpr_sempred(localctx: LogicExprContext, predIndex: number): boolean {
    switch (predIndex) {
      case 4:
        return this.precpred(this._ctx, 5)
      case 5:
        return this.precpred(this._ctx, 4)
      case 6:
        return this.precpred(this._ctx, 3)
      case 7:
        return this.precpred(this._ctx, 2)
    }
    return true
  }

  public static readonly _serializedATN: number[] = [
    4, 1, 72, 396, 2, 0, 7, 0, 2, 1, 7, 1, 2, 2, 7, 2, 2, 3, 7, 3, 2, 4, 7, 4, 2, 5, 7, 5, 2, 6, 7,
    6, 2, 7, 7, 7, 2, 8, 7, 8, 2, 9, 7, 9, 2, 10, 7, 10, 2, 11, 7, 11, 2, 12, 7, 12, 2, 13, 7, 13,
    2, 14, 7, 14, 2, 15, 7, 15, 2, 16, 7, 16, 2, 17, 7, 17, 2, 18, 7, 18, 2, 19, 7, 19, 2, 20, 7,
    20, 2, 21, 7, 21, 2, 22, 7, 22, 2, 23, 7, 23, 2, 24, 7, 24, 2, 25, 7, 25, 2, 26, 7, 26, 2, 27,
    7, 27, 2, 28, 7, 28, 2, 29, 7, 29, 2, 30, 7, 30, 2, 31, 7, 31, 2, 32, 7, 32, 2, 33, 7, 33, 2,
    34, 7, 34, 2, 35, 7, 35, 2, 36, 7, 36, 1, 0, 1, 0, 1, 0, 1, 0, 5, 0, 79, 8, 0, 10, 0, 12, 0, 82,
    9, 0, 1, 0, 3, 0, 85, 8, 0, 1, 1, 4, 1, 88, 8, 1, 11, 1, 12, 1, 89, 1, 1, 1, 1, 1, 2, 1, 2, 1,
    3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 5, 3, 105, 8, 3, 10, 3, 12, 3, 108, 9, 3, 1,
    4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 5, 4, 119, 8, 4, 10, 4, 12, 4, 122, 9, 4, 1,
    5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 1, 5, 3, 5, 136, 8, 5, 1, 6, 1,
    6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1,
    6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 1, 6, 3, 6, 168, 8, 6, 1,
    7, 1, 7, 1, 8, 1, 8, 1, 8, 5, 8, 175, 8, 8, 10, 8, 12, 8, 178, 9, 8, 1, 9, 1, 9, 1, 9, 1, 9, 1,
    10, 1, 10, 1, 10, 1, 10, 1, 10, 1, 10, 1, 11, 1, 11, 1, 11, 1, 11, 1, 12, 1, 12, 1, 12, 5, 12,
    197, 8, 12, 10, 12, 12, 12, 200, 9, 12, 1, 13, 1, 13, 1, 13, 1, 13, 1, 13, 1, 13, 1, 13, 1, 13,
    1, 13, 1, 13, 1, 13, 1, 13, 1, 13, 1, 13, 3, 13, 216, 8, 13, 1, 14, 1, 14, 1, 14, 1, 14, 1, 14,
    1, 14, 1, 14, 3, 14, 225, 8, 14, 1, 15, 1, 15, 3, 15, 229, 8, 15, 1, 16, 1, 16, 1, 16, 1, 16, 1,
    16, 3, 16, 236, 8, 16, 1, 17, 1, 17, 1, 17, 1, 17, 1, 17, 3, 17, 243, 8, 17, 1, 18, 1, 18, 1,
    18, 1, 18, 1, 18, 1, 18, 3, 18, 251, 8, 18, 1, 18, 1, 18, 1, 18, 1, 18, 1, 18, 1, 18, 1, 18, 1,
    18, 1, 18, 1, 18, 1, 18, 1, 18, 5, 18, 265, 8, 18, 10, 18, 12, 18, 268, 9, 18, 1, 19, 1, 19, 1,
    19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 3, 19, 281, 8, 19, 1, 20, 1, 20, 1,
    20, 1, 20, 1, 20, 1, 21, 1, 21, 3, 21, 290, 8, 21, 1, 21, 1, 21, 1, 21, 3, 21, 295, 8, 21, 1,
    22, 1, 22, 3, 22, 299, 8, 22, 1, 22, 1, 22, 1, 22, 1, 23, 1, 23, 3, 23, 306, 8, 23, 1, 23, 1,
    23, 1, 23, 3, 23, 311, 8, 23, 1, 24, 1, 24, 1, 24, 1, 24, 3, 24, 317, 8, 24, 1, 25, 1, 25, 1,
    25, 1, 26, 1, 26, 1, 26, 3, 26, 325, 8, 26, 1, 27, 1, 27, 1, 27, 1, 27, 1, 27, 1, 27, 3, 27,
    333, 8, 27, 1, 28, 1, 28, 1, 28, 3, 28, 338, 8, 28, 1, 29, 1, 29, 3, 29, 342, 8, 29, 1, 30, 1,
    30, 3, 30, 346, 8, 30, 1, 31, 1, 31, 3, 31, 350, 8, 31, 1, 32, 1, 32, 1, 32, 1, 32, 1, 32, 3,
    32, 357, 8, 32, 1, 33, 1, 33, 1, 33, 3, 33, 362, 8, 33, 1, 33, 1, 33, 1, 33, 3, 33, 367, 8, 33,
    5, 33, 369, 8, 33, 10, 33, 12, 33, 372, 9, 33, 1, 33, 1, 33, 1, 33, 1, 33, 1, 33, 1, 33, 5, 33,
    380, 8, 33, 10, 33, 12, 33, 383, 9, 33, 1, 33, 1, 33, 3, 33, 387, 8, 33, 1, 34, 1, 34, 1, 35, 1,
    35, 1, 35, 1, 36, 1, 36, 1, 36, 0, 3, 6, 8, 36, 37, 0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22,
    24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62, 64, 66, 68, 70,
    72, 0, 1, 2, 0, 8, 8, 18, 18, 445, 0, 84, 1, 0, 0, 0, 2, 87, 1, 0, 0, 0, 4, 93, 1, 0, 0, 0, 6,
    95, 1, 0, 0, 0, 8, 109, 1, 0, 0, 0, 10, 135, 1, 0, 0, 0, 12, 167, 1, 0, 0, 0, 14, 169, 1, 0, 0,
    0, 16, 171, 1, 0, 0, 0, 18, 179, 1, 0, 0, 0, 20, 183, 1, 0, 0, 0, 22, 189, 1, 0, 0, 0, 24, 193,
    1, 0, 0, 0, 26, 215, 1, 0, 0, 0, 28, 224, 1, 0, 0, 0, 30, 228, 1, 0, 0, 0, 32, 235, 1, 0, 0, 0,
    34, 242, 1, 0, 0, 0, 36, 250, 1, 0, 0, 0, 38, 280, 1, 0, 0, 0, 40, 282, 1, 0, 0, 0, 42, 289, 1,
    0, 0, 0, 44, 298, 1, 0, 0, 0, 46, 305, 1, 0, 0, 0, 48, 312, 1, 0, 0, 0, 50, 318, 1, 0, 0, 0, 52,
    324, 1, 0, 0, 0, 54, 332, 1, 0, 0, 0, 56, 337, 1, 0, 0, 0, 58, 341, 1, 0, 0, 0, 60, 345, 1, 0,
    0, 0, 62, 349, 1, 0, 0, 0, 64, 356, 1, 0, 0, 0, 66, 386, 1, 0, 0, 0, 68, 388, 1, 0, 0, 0, 70,
    390, 1, 0, 0, 0, 72, 393, 1, 0, 0, 0, 74, 75, 3, 4, 2, 0, 75, 76, 5, 0, 0, 1, 76, 85, 1, 0, 0,
    0, 77, 79, 3, 2, 1, 0, 78, 77, 1, 0, 0, 0, 79, 82, 1, 0, 0, 0, 80, 78, 1, 0, 0, 0, 80, 81, 1, 0,
    0, 0, 81, 83, 1, 0, 0, 0, 82, 80, 1, 0, 0, 0, 83, 85, 5, 0, 0, 1, 84, 74, 1, 0, 0, 0, 84, 80, 1,
    0, 0, 0, 85, 1, 1, 0, 0, 0, 86, 88, 5, 72, 0, 0, 87, 86, 1, 0, 0, 0, 88, 89, 1, 0, 0, 0, 89, 87,
    1, 0, 0, 0, 89, 90, 1, 0, 0, 0, 90, 91, 1, 0, 0, 0, 91, 92, 6, 1, -1, 0, 92, 3, 1, 0, 0, 0, 93,
    94, 3, 6, 3, 0, 94, 5, 1, 0, 0, 0, 95, 96, 6, 3, -1, 0, 96, 97, 3, 8, 4, 0, 97, 106, 1, 0, 0, 0,
    98, 99, 10, 3, 0, 0, 99, 100, 5, 9, 0, 0, 100, 105, 3, 8, 4, 0, 101, 102, 10, 2, 0, 0, 102, 103,
    5, 10, 0, 0, 103, 105, 3, 8, 4, 0, 104, 98, 1, 0, 0, 0, 104, 101, 1, 0, 0, 0, 105, 108, 1, 0, 0,
    0, 106, 104, 1, 0, 0, 0, 106, 107, 1, 0, 0, 0, 107, 7, 1, 0, 0, 0, 108, 106, 1, 0, 0, 0, 109,
    110, 6, 4, -1, 0, 110, 111, 3, 10, 5, 0, 111, 120, 1, 0, 0, 0, 112, 113, 10, 3, 0, 0, 113, 114,
    5, 11, 0, 0, 114, 119, 3, 10, 5, 0, 115, 116, 10, 2, 0, 0, 116, 117, 5, 12, 0, 0, 117, 119, 3,
    10, 5, 0, 118, 112, 1, 0, 0, 0, 118, 115, 1, 0, 0, 0, 119, 122, 1, 0, 0, 0, 120, 118, 1, 0, 0,
    0, 120, 121, 1, 0, 0, 0, 121, 9, 1, 0, 0, 0, 122, 120, 1, 0, 0, 0, 123, 124, 5, 13, 0, 0, 124,
    125, 3, 6, 3, 0, 125, 126, 5, 14, 0, 0, 126, 136, 1, 0, 0, 0, 127, 136, 3, 12, 6, 0, 128, 136,
    5, 1, 0, 0, 129, 136, 5, 2, 0, 0, 130, 131, 5, 10, 0, 0, 131, 136, 5, 2, 0, 0, 132, 136, 5, 3,
    0, 0, 133, 136, 5, 65, 0, 0, 134, 136, 5, 66, 0, 0, 135, 123, 1, 0, 0, 0, 135, 127, 1, 0, 0, 0,
    135, 128, 1, 0, 0, 0, 135, 129, 1, 0, 0, 0, 135, 130, 1, 0, 0, 0, 135, 132, 1, 0, 0, 0, 135,
    133, 1, 0, 0, 0, 135, 134, 1, 0, 0, 0, 136, 11, 1, 0, 0, 0, 137, 138, 3, 26, 13, 0, 138, 139, 5,
    13, 0, 0, 139, 140, 3, 14, 7, 0, 140, 141, 5, 14, 0, 0, 141, 168, 1, 0, 0, 0, 142, 143, 3, 28,
    14, 0, 143, 144, 5, 13, 0, 0, 144, 145, 3, 16, 8, 0, 145, 146, 5, 14, 0, 0, 146, 168, 1, 0, 0,
    0, 147, 148, 3, 30, 15, 0, 148, 149, 5, 13, 0, 0, 149, 150, 3, 18, 9, 0, 150, 151, 5, 14, 0, 0,
    151, 168, 1, 0, 0, 0, 152, 153, 3, 32, 16, 0, 153, 154, 5, 13, 0, 0, 154, 155, 3, 20, 10, 0,
    155, 156, 5, 14, 0, 0, 156, 168, 1, 0, 0, 0, 157, 158, 3, 34, 17, 0, 158, 159, 5, 13, 0, 0, 159,
    160, 3, 22, 11, 0, 160, 161, 5, 14, 0, 0, 161, 168, 1, 0, 0, 0, 162, 163, 5, 34, 0, 0, 163, 164,
    5, 13, 0, 0, 164, 165, 3, 24, 12, 0, 165, 166, 5, 14, 0, 0, 166, 168, 1, 0, 0, 0, 167, 137, 1,
    0, 0, 0, 167, 142, 1, 0, 0, 0, 167, 147, 1, 0, 0, 0, 167, 152, 1, 0, 0, 0, 167, 157, 1, 0, 0, 0,
    167, 162, 1, 0, 0, 0, 168, 13, 1, 0, 0, 0, 169, 170, 3, 4, 2, 0, 170, 15, 1, 0, 0, 0, 171, 176,
    3, 14, 7, 0, 172, 173, 5, 15, 0, 0, 173, 175, 3, 14, 7, 0, 174, 172, 1, 0, 0, 0, 175, 178, 1, 0,
    0, 0, 176, 174, 1, 0, 0, 0, 176, 177, 1, 0, 0, 0, 177, 17, 1, 0, 0, 0, 178, 176, 1, 0, 0, 0,
    179, 180, 3, 14, 7, 0, 180, 181, 5, 15, 0, 0, 181, 182, 3, 14, 7, 0, 182, 19, 1, 0, 0, 0, 183,
    184, 3, 14, 7, 0, 184, 185, 5, 15, 0, 0, 185, 186, 3, 14, 7, 0, 186, 187, 5, 15, 0, 0, 187, 188,
    3, 14, 7, 0, 188, 21, 1, 0, 0, 0, 189, 190, 3, 36, 18, 0, 190, 191, 5, 15, 0, 0, 191, 192, 3, 4,
    2, 0, 192, 23, 1, 0, 0, 0, 193, 198, 3, 22, 11, 0, 194, 195, 5, 15, 0, 0, 195, 197, 3, 22, 11,
    0, 196, 194, 1, 0, 0, 0, 197, 200, 1, 0, 0, 0, 198, 196, 1, 0, 0, 0, 198, 199, 1, 0, 0, 0, 199,
    25, 1, 0, 0, 0, 200, 198, 1, 0, 0, 0, 201, 216, 5, 40, 0, 0, 202, 216, 5, 41, 0, 0, 203, 216, 5,
    42, 0, 0, 204, 216, 5, 45, 0, 0, 205, 216, 5, 46, 0, 0, 206, 216, 5, 50, 0, 0, 207, 216, 5, 51,
    0, 0, 208, 216, 5, 52, 0, 0, 209, 216, 5, 53, 0, 0, 210, 216, 5, 62, 0, 0, 211, 216, 5, 63, 0,
    0, 212, 216, 5, 64, 0, 0, 213, 216, 5, 67, 0, 0, 214, 216, 5, 68, 0, 0, 215, 201, 1, 0, 0, 0,
    215, 202, 1, 0, 0, 0, 215, 203, 1, 0, 0, 0, 215, 204, 1, 0, 0, 0, 215, 205, 1, 0, 0, 0, 215,
    206, 1, 0, 0, 0, 215, 207, 1, 0, 0, 0, 215, 208, 1, 0, 0, 0, 215, 209, 1, 0, 0, 0, 215, 210, 1,
    0, 0, 0, 215, 211, 1, 0, 0, 0, 215, 212, 1, 0, 0, 0, 215, 213, 1, 0, 0, 0, 215, 214, 1, 0, 0, 0,
    216, 27, 1, 0, 0, 0, 217, 225, 5, 38, 0, 0, 218, 225, 5, 39, 0, 0, 219, 225, 5, 43, 0, 0, 220,
    225, 5, 44, 0, 0, 221, 225, 5, 54, 0, 0, 222, 225, 5, 47, 0, 0, 223, 225, 5, 69, 0, 0, 224, 217,
    1, 0, 0, 0, 224, 218, 1, 0, 0, 0, 224, 219, 1, 0, 0, 0, 224, 220, 1, 0, 0, 0, 224, 221, 1, 0, 0,
    0, 224, 222, 1, 0, 0, 0, 224, 223, 1, 0, 0, 0, 225, 29, 1, 0, 0, 0, 226, 229, 5, 55, 0, 0, 227,
    229, 5, 56, 0, 0, 228, 226, 1, 0, 0, 0, 228, 227, 1, 0, 0, 0, 229, 31, 1, 0, 0, 0, 230, 236, 5,
    58, 0, 0, 231, 236, 5, 57, 0, 0, 232, 236, 5, 59, 0, 0, 233, 236, 5, 60, 0, 0, 234, 236, 5, 61,
    0, 0, 235, 230, 1, 0, 0, 0, 235, 231, 1, 0, 0, 0, 235, 232, 1, 0, 0, 0, 235, 233, 1, 0, 0, 0,
    235, 234, 1, 0, 0, 0, 236, 33, 1, 0, 0, 0, 237, 243, 5, 35, 0, 0, 238, 243, 5, 36, 0, 0, 239,
    243, 5, 37, 0, 0, 240, 243, 5, 49, 0, 0, 241, 243, 5, 48, 0, 0, 242, 237, 1, 0, 0, 0, 242, 238,
    1, 0, 0, 0, 242, 239, 1, 0, 0, 0, 242, 240, 1, 0, 0, 0, 242, 241, 1, 0, 0, 0, 243, 35, 1, 0, 0,
    0, 244, 245, 6, 18, -1, 0, 245, 246, 5, 13, 0, 0, 246, 247, 3, 36, 18, 0, 247, 248, 5, 14, 0, 0,
    248, 251, 1, 0, 0, 0, 249, 251, 3, 38, 19, 0, 250, 244, 1, 0, 0, 0, 250, 249, 1, 0, 0, 0, 251,
    266, 1, 0, 0, 0, 252, 253, 10, 5, 0, 0, 253, 254, 5, 6, 0, 0, 254, 265, 3, 36, 18, 6, 255, 256,
    10, 4, 0, 0, 256, 257, 5, 16, 0, 0, 257, 265, 3, 36, 18, 5, 258, 259, 10, 3, 0, 0, 259, 260, 5,
    7, 0, 0, 260, 265, 3, 36, 18, 4, 261, 262, 10, 2, 0, 0, 262, 263, 5, 17, 0, 0, 263, 265, 3, 36,
    18, 3, 264, 252, 1, 0, 0, 0, 264, 255, 1, 0, 0, 0, 264, 258, 1, 0, 0, 0, 264, 261, 1, 0, 0, 0,
    265, 268, 1, 0, 0, 0, 266, 264, 1, 0, 0, 0, 266, 267, 1, 0, 0, 0, 267, 37, 1, 0, 0, 0, 268, 266,
    1, 0, 0, 0, 269, 270, 5, 13, 0, 0, 270, 271, 3, 38, 19, 0, 271, 272, 5, 14, 0, 0, 272, 281, 1,
    0, 0, 0, 273, 281, 3, 40, 20, 0, 274, 281, 5, 4, 0, 0, 275, 281, 3, 42, 21, 0, 276, 281, 3, 44,
    22, 0, 277, 281, 3, 46, 23, 0, 278, 281, 3, 50, 25, 0, 279, 281, 3, 48, 24, 0, 280, 269, 1, 0,
    0, 0, 280, 273, 1, 0, 0, 0, 280, 274, 1, 0, 0, 0, 280, 275, 1, 0, 0, 0, 280, 276, 1, 0, 0, 0,
    280, 277, 1, 0, 0, 0, 280, 278, 1, 0, 0, 0, 280, 279, 1, 0, 0, 0, 281, 39, 1, 0, 0, 0, 282, 283,
    7, 0, 0, 0, 283, 284, 5, 13, 0, 0, 284, 285, 3, 36, 18, 0, 285, 286, 5, 14, 0, 0, 286, 41, 1, 0,
    0, 0, 287, 290, 3, 66, 33, 0, 288, 290, 3, 52, 26, 0, 289, 287, 1, 0, 0, 0, 289, 288, 1, 0, 0,
    0, 290, 291, 1, 0, 0, 0, 291, 294, 3, 54, 27, 0, 292, 295, 3, 66, 33, 0, 293, 295, 3, 52, 26, 0,
    294, 292, 1, 0, 0, 0, 294, 293, 1, 0, 0, 0, 295, 43, 1, 0, 0, 0, 296, 299, 3, 66, 33, 0, 297,
    299, 3, 52, 26, 0, 298, 296, 1, 0, 0, 0, 298, 297, 1, 0, 0, 0, 299, 300, 1, 0, 0, 0, 300, 301,
    3, 58, 29, 0, 301, 302, 3, 52, 26, 0, 302, 45, 1, 0, 0, 0, 303, 306, 3, 66, 33, 0, 304, 306, 3,
    52, 26, 0, 305, 303, 1, 0, 0, 0, 305, 304, 1, 0, 0, 0, 306, 307, 1, 0, 0, 0, 307, 310, 3, 56,
    28, 0, 308, 311, 3, 66, 33, 0, 309, 311, 3, 52, 26, 0, 310, 308, 1, 0, 0, 0, 310, 309, 1, 0, 0,
    0, 311, 47, 1, 0, 0, 0, 312, 313, 3, 52, 26, 0, 313, 316, 3, 60, 30, 0, 314, 317, 3, 66, 33, 0,
    315, 317, 3, 52, 26, 0, 316, 314, 1, 0, 0, 0, 316, 315, 1, 0, 0, 0, 317, 49, 1, 0, 0, 0, 318,
    319, 3, 52, 26, 0, 319, 320, 3, 62, 31, 0, 320, 51, 1, 0, 0, 0, 321, 325, 5, 1, 0, 0, 322, 325,
    3, 4, 2, 0, 323, 325, 3, 64, 32, 0, 324, 321, 1, 0, 0, 0, 324, 322, 1, 0, 0, 0, 324, 323, 1, 0,
    0, 0, 325, 53, 1, 0, 0, 0, 326, 333, 5, 19, 0, 0, 327, 333, 5, 20, 0, 0, 328, 333, 5, 21, 0, 0,
    329, 333, 5, 22, 0, 0, 330, 333, 5, 23, 0, 0, 331, 333, 5, 24, 0, 0, 332, 326, 1, 0, 0, 0, 332,
    327, 1, 0, 0, 0, 332, 328, 1, 0, 0, 0, 332, 329, 1, 0, 0, 0, 332, 330, 1, 0, 0, 0, 332, 331, 1,
    0, 0, 0, 333, 55, 1, 0, 0, 0, 334, 338, 5, 27, 0, 0, 335, 338, 5, 28, 0, 0, 336, 338, 5, 29, 0,
    0, 337, 334, 1, 0, 0, 0, 337, 335, 1, 0, 0, 0, 337, 336, 1, 0, 0, 0, 338, 57, 1, 0, 0, 0, 339,
    342, 5, 25, 0, 0, 340, 342, 5, 26, 0, 0, 341, 339, 1, 0, 0, 0, 341, 340, 1, 0, 0, 0, 342, 59, 1,
    0, 0, 0, 343, 346, 5, 32, 0, 0, 344, 346, 5, 33, 0, 0, 345, 343, 1, 0, 0, 0, 345, 344, 1, 0, 0,
    0, 346, 61, 1, 0, 0, 0, 347, 350, 5, 30, 0, 0, 348, 350, 5, 31, 0, 0, 349, 347, 1, 0, 0, 0, 349,
    348, 1, 0, 0, 0, 350, 63, 1, 0, 0, 0, 351, 357, 5, 2, 0, 0, 352, 353, 5, 10, 0, 0, 353, 357, 5,
    2, 0, 0, 354, 357, 5, 3, 0, 0, 355, 357, 5, 4, 0, 0, 356, 351, 1, 0, 0, 0, 356, 352, 1, 0, 0, 0,
    356, 354, 1, 0, 0, 0, 356, 355, 1, 0, 0, 0, 357, 65, 1, 0, 0, 0, 358, 361, 5, 13, 0, 0, 359,
    362, 3, 68, 34, 0, 360, 362, 3, 70, 35, 0, 361, 359, 1, 0, 0, 0, 361, 360, 1, 0, 0, 0, 362, 370,
    1, 0, 0, 0, 363, 366, 5, 15, 0, 0, 364, 367, 3, 68, 34, 0, 365, 367, 3, 70, 35, 0, 366, 364, 1,
    0, 0, 0, 366, 365, 1, 0, 0, 0, 367, 369, 1, 0, 0, 0, 368, 363, 1, 0, 0, 0, 369, 372, 1, 0, 0, 0,
    370, 368, 1, 0, 0, 0, 370, 371, 1, 0, 0, 0, 371, 373, 1, 0, 0, 0, 372, 370, 1, 0, 0, 0, 373,
    374, 5, 14, 0, 0, 374, 387, 1, 0, 0, 0, 375, 376, 5, 13, 0, 0, 376, 381, 3, 72, 36, 0, 377, 378,
    5, 15, 0, 0, 378, 380, 3, 72, 36, 0, 379, 377, 1, 0, 0, 0, 380, 383, 1, 0, 0, 0, 381, 379, 1, 0,
    0, 0, 381, 382, 1, 0, 0, 0, 382, 384, 1, 0, 0, 0, 383, 381, 1, 0, 0, 0, 384, 385, 5, 14, 0, 0,
    385, 387, 1, 0, 0, 0, 386, 358, 1, 0, 0, 0, 386, 375, 1, 0, 0, 0, 387, 67, 1, 0, 0, 0, 388, 389,
    5, 2, 0, 0, 389, 69, 1, 0, 0, 0, 390, 391, 5, 10, 0, 0, 391, 392, 5, 2, 0, 0, 392, 71, 1, 0, 0,
    0, 393, 394, 5, 3, 0, 0, 394, 73, 1, 0, 0, 0, 38, 80, 84, 89, 104, 106, 118, 120, 135, 167, 176,
    198, 215, 224, 228, 235, 242, 250, 264, 266, 280, 289, 294, 298, 305, 310, 316, 324, 332, 337,
    341, 345, 349, 356, 361, 366, 370, 381, 386,
  ]

  private static __ATN: ATN
  public static get _ATN(): ATN {
    if (!formulaParser.__ATN) {
      formulaParser.__ATN = new ATNDeserializer().deserialize(formulaParser._serializedATN)
    }

    return formulaParser.__ATN
  }

  static DecisionsToDFA = formulaParser._ATN.decisionToState.map(
    (ds: DecisionState, index: number) => new DFA(ds, index),
  )
}

export class ExprContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public formulaExpr(): FormulaExprContext {
    return this.getTypedRuleContext(FormulaExprContext, 0) as FormulaExprContext
  }
  public EOF(): TerminalNode {
    return this.getToken(formulaParser.EOF, 0)
  }
  public invalidInput_list(): InvalidInputContext[] {
    return this.getTypedRuleContexts(InvalidInputContext) as InvalidInputContext[]
  }
  public invalidInput(i: number): InvalidInputContext {
    return this.getTypedRuleContext(InvalidInputContext, i) as InvalidInputContext
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_expr
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterExpr) {
      listener.enterExpr(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitExpr) {
      listener.exitExpr(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitExpr) {
      return visitor.visitExpr(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class InvalidInputContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public INVALID_INPUT_list(): TerminalNode[] {
    return this.getTokens(formulaParser.INVALID_INPUT)
  }
  public INVALID_INPUT(i: number): TerminalNode {
    return this.getToken(formulaParser.INVALID_INPUT, i)
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_invalidInput
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterInvalidInput) {
      listener.enterInvalidInput(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitInvalidInput) {
      listener.exitInvalidInput(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitInvalidInput) {
      return visitor.visitInvalidInput(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class FormulaExprContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_formulaExpr
  }
  public override copyFrom(ctx: FormulaExprContext): void {
    super.copyFrom(ctx)
  }
}
export class SumExpressionContext extends FormulaExprContext {
  constructor(parser: formulaParser, ctx: FormulaExprContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public sumExpr(): SumExprContext {
    return this.getTypedRuleContext(SumExprContext, 0) as SumExprContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterSumExpression) {
      listener.enterSumExpression(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitSumExpression) {
      listener.exitSumExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitSumExpression) {
      return visitor.visitSumExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class SumExprContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_sumExpr
  }
  public override copyFrom(ctx: SumExprContext): void {
    super.copyFrom(ctx)
  }
}
export class SingleTermContext extends SumExprContext {
  constructor(parser: formulaParser, ctx: SumExprContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public term(): TermContext {
    return this.getTypedRuleContext(TermContext, 0) as TermContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterSingleTerm) {
      listener.enterSingleTerm(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitSingleTerm) {
      listener.exitSingleTerm(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitSingleTerm) {
      return visitor.visitSingleTerm(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class AdditionExprContext extends SumExprContext {
  constructor(parser: formulaParser, ctx: SumExprContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public sumExpr(): SumExprContext {
    return this.getTypedRuleContext(SumExprContext, 0) as SumExprContext
  }
  public PLUS(): TerminalNode {
    return this.getToken(formulaParser.PLUS, 0)
  }
  public term(): TermContext {
    return this.getTypedRuleContext(TermContext, 0) as TermContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterAdditionExpr) {
      listener.enterAdditionExpr(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitAdditionExpr) {
      listener.exitAdditionExpr(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitAdditionExpr) {
      return visitor.visitAdditionExpr(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class SubtractionExprContext extends SumExprContext {
  constructor(parser: formulaParser, ctx: SumExprContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public sumExpr(): SumExprContext {
    return this.getTypedRuleContext(SumExprContext, 0) as SumExprContext
  }
  public MINUS(): TerminalNode {
    return this.getToken(formulaParser.MINUS, 0)
  }
  public term(): TermContext {
    return this.getTypedRuleContext(TermContext, 0) as TermContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterSubtractionExpr) {
      listener.enterSubtractionExpr(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitSubtractionExpr) {
      listener.exitSubtractionExpr(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitSubtractionExpr) {
      return visitor.visitSubtractionExpr(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class TermContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_term
  }
  public override copyFrom(ctx: TermContext): void {
    super.copyFrom(ctx)
  }
}
export class SingleFactorContext extends TermContext {
  constructor(parser: formulaParser, ctx: TermContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public factor(): FactorContext {
    return this.getTypedRuleContext(FactorContext, 0) as FactorContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterSingleFactor) {
      listener.enterSingleFactor(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitSingleFactor) {
      listener.exitSingleFactor(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitSingleFactor) {
      return visitor.visitSingleFactor(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class MultiplicationExprContext extends TermContext {
  constructor(parser: formulaParser, ctx: TermContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public term(): TermContext {
    return this.getTypedRuleContext(TermContext, 0) as TermContext
  }
  public MULTIPLY(): TerminalNode {
    return this.getToken(formulaParser.MULTIPLY, 0)
  }
  public factor(): FactorContext {
    return this.getTypedRuleContext(FactorContext, 0) as FactorContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterMultiplicationExpr) {
      listener.enterMultiplicationExpr(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitMultiplicationExpr) {
      listener.exitMultiplicationExpr(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitMultiplicationExpr) {
      return visitor.visitMultiplicationExpr(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class DivisionExprContext extends TermContext {
  constructor(parser: formulaParser, ctx: TermContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public term(): TermContext {
    return this.getTypedRuleContext(TermContext, 0) as TermContext
  }
  public DIVIDE(): TerminalNode {
    return this.getToken(formulaParser.DIVIDE, 0)
  }
  public factor(): FactorContext {
    return this.getTypedRuleContext(FactorContext, 0) as FactorContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterDivisionExpr) {
      listener.enterDivisionExpr(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitDivisionExpr) {
      listener.exitDivisionExpr(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitDivisionExpr) {
      return visitor.visitDivisionExpr(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class FactorContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_factor
  }
  public override copyFrom(ctx: FactorContext): void {
    super.copyFrom(ctx)
  }
}
export class NestedSumExprContext extends FactorContext {
  constructor(parser: formulaParser, ctx: FactorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public LEFT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.LEFT_PAREN, 0)
  }
  public sumExpr(): SumExprContext {
    return this.getTypedRuleContext(SumExprContext, 0) as SumExprContext
  }
  public RIGHT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.RIGHT_PAREN, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterNestedSumExpr) {
      listener.enterNestedSumExpr(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitNestedSumExpr) {
      listener.exitNestedSumExpr(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitNestedSumExpr) {
      return visitor.visitNestedSumExpr(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class NumberContext extends FactorContext {
  constructor(parser: formulaParser, ctx: FactorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public NUMBER(): TerminalNode {
    return this.getToken(formulaParser.NUMBER, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterNumber) {
      listener.enterNumber(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitNumber) {
      listener.exitNumber(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitNumber) {
      return visitor.visitNumber(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class TodayLiteralContext extends FactorContext {
  constructor(parser: formulaParser, ctx: FactorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public TODAY(): TerminalNode {
    return this.getToken(formulaParser.TODAY, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterTodayLiteral) {
      listener.enterTodayLiteral(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitTodayLiteral) {
      listener.exitTodayLiteral(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitTodayLiteral) {
      return visitor.visitTodayLiteral(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class StringLiteralContext extends FactorContext {
  constructor(parser: formulaParser, ctx: FactorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public STRING(): TerminalNode {
    return this.getToken(formulaParser.STRING, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterStringLiteral) {
      listener.enterStringLiteral(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitStringLiteral) {
      listener.exitStringLiteral(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitStringLiteral) {
      return visitor.visitStringLiteral(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class NowLiteralContext extends FactorContext {
  constructor(parser: formulaParser, ctx: FactorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public NOW(): TerminalNode {
    return this.getToken(formulaParser.NOW, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterNowLiteral) {
      listener.enterNowLiteral(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitNowLiteral) {
      listener.exitNowLiteral(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitNowLiteral) {
      return visitor.visitNowLiteral(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class FunctionContext extends FactorContext {
  constructor(parser: formulaParser, ctx: FactorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public functionCall(): FunctionCallContext {
    return this.getTypedRuleContext(FunctionCallContext, 0) as FunctionCallContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterFunction) {
      listener.enterFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitFunction) {
      listener.exitFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitFunction) {
      return visitor.visitFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class NegativeNumberContext extends FactorContext {
  constructor(parser: formulaParser, ctx: FactorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public MINUS(): TerminalNode {
    return this.getToken(formulaParser.MINUS, 0)
  }
  public NUMBER(): TerminalNode {
    return this.getToken(formulaParser.NUMBER, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterNegativeNumber) {
      listener.enterNegativeNumber(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitNegativeNumber) {
      listener.exitNegativeNumber(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitNegativeNumber) {
      return visitor.visitNegativeNumber(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class ColumnRefContext extends FactorContext {
  constructor(parser: formulaParser, ctx: FactorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public COLUMN_ID(): TerminalNode {
    return this.getToken(formulaParser.COLUMN_ID, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterColumnRef) {
      listener.enterColumnRef(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitColumnRef) {
      listener.exitColumnRef(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitColumnRef) {
      return visitor.visitColumnRef(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class FunctionCallContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_functionCall
  }
  public override copyFrom(ctx: FunctionCallContext): void {
    super.copyFrom(ctx)
  }
}
export class SingleArgumentFunctionContext extends FunctionCallContext {
  constructor(parser: formulaParser, ctx: FunctionCallContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public singleArgFunctionType(): SingleArgFunctionTypeContext {
    return this.getTypedRuleContext(SingleArgFunctionTypeContext, 0) as SingleArgFunctionTypeContext
  }
  public LEFT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.LEFT_PAREN, 0)
  }
  public singleArg(): SingleArgContext {
    return this.getTypedRuleContext(SingleArgContext, 0) as SingleArgContext
  }
  public RIGHT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.RIGHT_PAREN, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterSingleArgumentFunction) {
      listener.enterSingleArgumentFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitSingleArgumentFunction) {
      listener.exitSingleArgumentFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitSingleArgumentFunction) {
      return visitor.visitSingleArgumentFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class ThreeArgumentsFunctionContext extends FunctionCallContext {
  constructor(parser: formulaParser, ctx: FunctionCallContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public threeArgsFunctionType(): ThreeArgsFunctionTypeContext {
    return this.getTypedRuleContext(ThreeArgsFunctionTypeContext, 0) as ThreeArgsFunctionTypeContext
  }
  public LEFT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.LEFT_PAREN, 0)
  }
  public threeArgs(): ThreeArgsContext {
    return this.getTypedRuleContext(ThreeArgsContext, 0) as ThreeArgsContext
  }
  public RIGHT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.RIGHT_PAREN, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterThreeArgumentsFunction) {
      listener.enterThreeArgumentsFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitThreeArgumentsFunction) {
      listener.exitThreeArgumentsFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitThreeArgumentsFunction) {
      return visitor.visitThreeArgumentsFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class IfsFunctionContext extends FunctionCallContext {
  constructor(parser: formulaParser, ctx: FunctionCallContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public IFS(): TerminalNode {
    return this.getToken(formulaParser.IFS, 0)
  }
  public LEFT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.LEFT_PAREN, 0)
  }
  public ifsArgs(): IfsArgsContext {
    return this.getTypedRuleContext(IfsArgsContext, 0) as IfsArgsContext
  }
  public RIGHT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.RIGHT_PAREN, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterIfsFunction) {
      listener.enterIfsFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitIfsFunction) {
      listener.exitIfsFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitIfsFunction) {
      return visitor.visitIfsFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class IfFunctionContext extends FunctionCallContext {
  constructor(parser: formulaParser, ctx: FunctionCallContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public ifFunctionType(): IfFunctionTypeContext {
    return this.getTypedRuleContext(IfFunctionTypeContext, 0) as IfFunctionTypeContext
  }
  public LEFT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.LEFT_PAREN, 0)
  }
  public ifArgs(): IfArgsContext {
    return this.getTypedRuleContext(IfArgsContext, 0) as IfArgsContext
  }
  public RIGHT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.RIGHT_PAREN, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterIfFunction) {
      listener.enterIfFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitIfFunction) {
      listener.exitIfFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitIfFunction) {
      return visitor.visitIfFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class TwoArgumentsFunctionContext extends FunctionCallContext {
  constructor(parser: formulaParser, ctx: FunctionCallContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public twoArgsFunctionType(): TwoArgsFunctionTypeContext {
    return this.getTypedRuleContext(TwoArgsFunctionTypeContext, 0) as TwoArgsFunctionTypeContext
  }
  public LEFT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.LEFT_PAREN, 0)
  }
  public twoArgs(): TwoArgsContext {
    return this.getTypedRuleContext(TwoArgsContext, 0) as TwoArgsContext
  }
  public RIGHT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.RIGHT_PAREN, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterTwoArgumentsFunction) {
      listener.enterTwoArgumentsFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitTwoArgumentsFunction) {
      listener.exitTwoArgumentsFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitTwoArgumentsFunction) {
      return visitor.visitTwoArgumentsFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class MultipleArgumentsFunctionContext extends FunctionCallContext {
  constructor(parser: formulaParser, ctx: FunctionCallContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public multipleArgsFunctionType(): MultipleArgsFunctionTypeContext {
    return this.getTypedRuleContext(
      MultipleArgsFunctionTypeContext,
      0,
    ) as MultipleArgsFunctionTypeContext
  }
  public LEFT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.LEFT_PAREN, 0)
  }
  public multipleArgs(): MultipleArgsContext {
    return this.getTypedRuleContext(MultipleArgsContext, 0) as MultipleArgsContext
  }
  public RIGHT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.RIGHT_PAREN, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterMultipleArgumentsFunction) {
      listener.enterMultipleArgumentsFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitMultipleArgumentsFunction) {
      listener.exitMultipleArgumentsFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitMultipleArgumentsFunction) {
      return visitor.visitMultipleArgumentsFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class SingleArgContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_singleArg
  }
  public override copyFrom(ctx: SingleArgContext): void {
    super.copyFrom(ctx)
  }
}
export class SingleExpressionContext extends SingleArgContext {
  constructor(parser: formulaParser, ctx: SingleArgContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public formulaExpr(): FormulaExprContext {
    return this.getTypedRuleContext(FormulaExprContext, 0) as FormulaExprContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterSingleExpression) {
      listener.enterSingleExpression(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitSingleExpression) {
      listener.exitSingleExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitSingleExpression) {
      return visitor.visitSingleExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class MultipleArgsContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_multipleArgs
  }
  public override copyFrom(ctx: MultipleArgsContext): void {
    super.copyFrom(ctx)
  }
}
export class MultipleExpressionsContext extends MultipleArgsContext {
  constructor(parser: formulaParser, ctx: MultipleArgsContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public singleArg_list(): SingleArgContext[] {
    return this.getTypedRuleContexts(SingleArgContext) as SingleArgContext[]
  }
  public singleArg(i: number): SingleArgContext {
    return this.getTypedRuleContext(SingleArgContext, i) as SingleArgContext
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(formulaParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(formulaParser.COMMA, i)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterMultipleExpressions) {
      listener.enterMultipleExpressions(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitMultipleExpressions) {
      listener.exitMultipleExpressions(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitMultipleExpressions) {
      return visitor.visitMultipleExpressions(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class TwoArgsContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_twoArgs
  }
  public override copyFrom(ctx: TwoArgsContext): void {
    super.copyFrom(ctx)
  }
}
export class TwoExpressionArgsContext extends TwoArgsContext {
  constructor(parser: formulaParser, ctx: TwoArgsContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public singleArg_list(): SingleArgContext[] {
    return this.getTypedRuleContexts(SingleArgContext) as SingleArgContext[]
  }
  public singleArg(i: number): SingleArgContext {
    return this.getTypedRuleContext(SingleArgContext, i) as SingleArgContext
  }
  public COMMA(): TerminalNode {
    return this.getToken(formulaParser.COMMA, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterTwoExpressionArgs) {
      listener.enterTwoExpressionArgs(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitTwoExpressionArgs) {
      listener.exitTwoExpressionArgs(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitTwoExpressionArgs) {
      return visitor.visitTwoExpressionArgs(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ThreeArgsContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_threeArgs
  }
  public override copyFrom(ctx: ThreeArgsContext): void {
    super.copyFrom(ctx)
  }
}
export class ThreeExpressionArgsContext extends ThreeArgsContext {
  constructor(parser: formulaParser, ctx: ThreeArgsContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public singleArg_list(): SingleArgContext[] {
    return this.getTypedRuleContexts(SingleArgContext) as SingleArgContext[]
  }
  public singleArg(i: number): SingleArgContext {
    return this.getTypedRuleContext(SingleArgContext, i) as SingleArgContext
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(formulaParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(formulaParser.COMMA, i)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterThreeExpressionArgs) {
      listener.enterThreeExpressionArgs(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitThreeExpressionArgs) {
      listener.exitThreeExpressionArgs(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitThreeExpressionArgs) {
      return visitor.visitThreeExpressionArgs(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class IfArgsContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_ifArgs
  }
  public override copyFrom(ctx: IfArgsContext): void {
    super.copyFrom(ctx)
  }
}
export class TwoExpressionsContext extends IfArgsContext {
  constructor(parser: formulaParser, ctx: IfArgsContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public logicExpr(): LogicExprContext {
    return this.getTypedRuleContext(LogicExprContext, 0) as LogicExprContext
  }
  public COMMA(): TerminalNode {
    return this.getToken(formulaParser.COMMA, 0)
  }
  public formulaExpr(): FormulaExprContext {
    return this.getTypedRuleContext(FormulaExprContext, 0) as FormulaExprContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterTwoExpressions) {
      listener.enterTwoExpressions(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitTwoExpressions) {
      listener.exitTwoExpressions(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitTwoExpressions) {
      return visitor.visitTwoExpressions(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class IfsArgsContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_ifsArgs
  }
  public override copyFrom(ctx: IfsArgsContext): void {
    super.copyFrom(ctx)
  }
}
export class EvenExpressionsContext extends IfsArgsContext {
  constructor(parser: formulaParser, ctx: IfsArgsContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public ifArgs_list(): IfArgsContext[] {
    return this.getTypedRuleContexts(IfArgsContext) as IfArgsContext[]
  }
  public ifArgs(i: number): IfArgsContext {
    return this.getTypedRuleContext(IfArgsContext, i) as IfArgsContext
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(formulaParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(formulaParser.COMMA, i)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterEvenExpressions) {
      listener.enterEvenExpressions(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitEvenExpressions) {
      listener.exitEvenExpressions(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitEvenExpressions) {
      return visitor.visitEvenExpressions(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class SingleArgFunctionTypeContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_singleArgFunctionType
  }
  public override copyFrom(ctx: SingleArgFunctionTypeContext): void {
    super.copyFrom(ctx)
  }
}
export class LowerFunctionContext extends SingleArgFunctionTypeContext {
  constructor(parser: formulaParser, ctx: SingleArgFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public LOWER(): TerminalNode {
    return this.getToken(formulaParser.LOWER, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterLowerFunction) {
      listener.enterLowerFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitLowerFunction) {
      listener.exitLowerFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitLowerFunction) {
      return visitor.visitLowerFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class ToNumberFunctionContext extends SingleArgFunctionTypeContext {
  constructor(parser: formulaParser, ctx: SingleArgFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public TO_NUMBER(): TerminalNode {
    return this.getToken(formulaParser.TO_NUMBER, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterToNumberFunction) {
      listener.enterToNumberFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitToNumberFunction) {
      listener.exitToNumberFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitToNumberFunction) {
      return visitor.visitToNumberFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class CountDistinctFunctionContext extends SingleArgFunctionTypeContext {
  constructor(parser: formulaParser, ctx: SingleArgFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public COUNT_DISTINCT(): TerminalNode {
    return this.getToken(formulaParser.COUNT_DISTINCT, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterCountDistinctFunction) {
      listener.enterCountDistinctFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitCountDistinctFunction) {
      listener.exitCountDistinctFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitCountDistinctFunction) {
      return visitor.visitCountDistinctFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class CeilFunctionContext extends SingleArgFunctionTypeContext {
  constructor(parser: formulaParser, ctx: SingleArgFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public CEIL(): TerminalNode {
    return this.getToken(formulaParser.CEIL, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterCeilFunction) {
      listener.enterCeilFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitCeilFunction) {
      listener.exitCeilFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitCeilFunction) {
      return visitor.visitCeilFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class LenFunctionContext extends SingleArgFunctionTypeContext {
  constructor(parser: formulaParser, ctx: SingleArgFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public LEN(): TerminalNode {
    return this.getToken(formulaParser.LEN, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterLenFunction) {
      listener.enterLenFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitLenFunction) {
      listener.exitLenFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitLenFunction) {
      return visitor.visitLenFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class MonthFunctionContext extends SingleArgFunctionTypeContext {
  constructor(parser: formulaParser, ctx: SingleArgFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public MONTH(): TerminalNode {
    return this.getToken(formulaParser.MONTH, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterMonthFunction) {
      listener.enterMonthFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitMonthFunction) {
      listener.exitMonthFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitMonthFunction) {
      return visitor.visitMonthFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class ToTextFunctionContext extends SingleArgFunctionTypeContext {
  constructor(parser: formulaParser, ctx: SingleArgFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public TO_TEXT(): TerminalNode {
    return this.getToken(formulaParser.TO_TEXT, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterToTextFunction) {
      listener.enterToTextFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitToTextFunction) {
      listener.exitToTextFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitToTextFunction) {
      return visitor.visitToTextFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class FloorFunctionContext extends SingleArgFunctionTypeContext {
  constructor(parser: formulaParser, ctx: SingleArgFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public FLOOR(): TerminalNode {
    return this.getToken(formulaParser.FLOOR, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterFloorFunction) {
      listener.enterFloorFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitFloorFunction) {
      listener.exitFloorFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitFloorFunction) {
      return visitor.visitFloorFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class CountFunctionContext extends SingleArgFunctionTypeContext {
  constructor(parser: formulaParser, ctx: SingleArgFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public COUNT(): TerminalNode {
    return this.getToken(formulaParser.COUNT, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterCountFunction) {
      listener.enterCountFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitCountFunction) {
      listener.exitCountFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitCountFunction) {
      return visitor.visitCountFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class SumFunctionContext extends SingleArgFunctionTypeContext {
  constructor(parser: formulaParser, ctx: SingleArgFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public SUM(): TerminalNode {
    return this.getToken(formulaParser.SUM, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterSumFunction) {
      listener.enterSumFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitSumFunction) {
      listener.exitSumFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitSumFunction) {
      return visitor.visitSumFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class TrimFunctionContext extends SingleArgFunctionTypeContext {
  constructor(parser: formulaParser, ctx: SingleArgFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public TRIM(): TerminalNode {
    return this.getToken(formulaParser.TRIM, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterTrimFunction) {
      listener.enterTrimFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitTrimFunction) {
      listener.exitTrimFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitTrimFunction) {
      return visitor.visitTrimFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class YearFunctionContext extends SingleArgFunctionTypeContext {
  constructor(parser: formulaParser, ctx: SingleArgFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public YEAR(): TerminalNode {
    return this.getToken(formulaParser.YEAR, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterYearFunction) {
      listener.enterYearFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitYearFunction) {
      listener.exitYearFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitYearFunction) {
      return visitor.visitYearFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class UpperFunctionContext extends SingleArgFunctionTypeContext {
  constructor(parser: formulaParser, ctx: SingleArgFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public UPPER(): TerminalNode {
    return this.getToken(formulaParser.UPPER, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterUpperFunction) {
      listener.enterUpperFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitUpperFunction) {
      listener.exitUpperFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitUpperFunction) {
      return visitor.visitUpperFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class DayFunctionContext extends SingleArgFunctionTypeContext {
  constructor(parser: formulaParser, ctx: SingleArgFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public DAY(): TerminalNode {
    return this.getToken(formulaParser.DAY, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterDayFunction) {
      listener.enterDayFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitDayFunction) {
      listener.exitDayFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitDayFunction) {
      return visitor.visitDayFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class MultipleArgsFunctionTypeContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_multipleArgsFunctionType
  }
  public override copyFrom(ctx: MultipleArgsFunctionTypeContext): void {
    super.copyFrom(ctx)
  }
}
export class SumProductFunctionContext extends MultipleArgsFunctionTypeContext {
  constructor(parser: formulaParser, ctx: MultipleArgsFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public SUMPRODUCT(): TerminalNode {
    return this.getToken(formulaParser.SUMPRODUCT, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterSumProductFunction) {
      listener.enterSumProductFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitSumProductFunction) {
      listener.exitSumProductFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitSumProductFunction) {
      return visitor.visitSumProductFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class ConcatFunctionContext extends MultipleArgsFunctionTypeContext {
  constructor(parser: formulaParser, ctx: MultipleArgsFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public CONCAT(): TerminalNode {
    return this.getToken(formulaParser.CONCAT, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterConcatFunction) {
      listener.enterConcatFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitConcatFunction) {
      listener.exitConcatFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitConcatFunction) {
      return visitor.visitConcatFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class ToDateFunctionContext extends MultipleArgsFunctionTypeContext {
  constructor(parser: formulaParser, ctx: MultipleArgsFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public TO_DATE(): TerminalNode {
    return this.getToken(formulaParser.TO_DATE, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterToDateFunction) {
      listener.enterToDateFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitToDateFunction) {
      listener.exitToDateFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitToDateFunction) {
      return visitor.visitToDateFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class MinFunctionContext extends MultipleArgsFunctionTypeContext {
  constructor(parser: formulaParser, ctx: MultipleArgsFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public MIN(): TerminalNode {
    return this.getToken(formulaParser.MIN, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterMinFunction) {
      listener.enterMinFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitMinFunction) {
      listener.exitMinFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitMinFunction) {
      return visitor.visitMinFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class AverageFunctionContext extends MultipleArgsFunctionTypeContext {
  constructor(parser: formulaParser, ctx: MultipleArgsFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public AVERAGE(): TerminalNode {
    return this.getToken(formulaParser.AVERAGE, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterAverageFunction) {
      listener.enterAverageFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitAverageFunction) {
      listener.exitAverageFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitAverageFunction) {
      return visitor.visitAverageFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class MaxFunctionContext extends MultipleArgsFunctionTypeContext {
  constructor(parser: formulaParser, ctx: MultipleArgsFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public MAX(): TerminalNode {
    return this.getToken(formulaParser.MAX, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterMaxFunction) {
      listener.enterMaxFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitMaxFunction) {
      listener.exitMaxFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitMaxFunction) {
      return visitor.visitMaxFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class RoundFunctionContext extends MultipleArgsFunctionTypeContext {
  constructor(parser: formulaParser, ctx: MultipleArgsFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public ROUND(): TerminalNode {
    return this.getToken(formulaParser.ROUND, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterRoundFunction) {
      listener.enterRoundFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitRoundFunction) {
      listener.exitRoundFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitRoundFunction) {
      return visitor.visitRoundFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class TwoArgsFunctionTypeContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_twoArgsFunctionType
  }
  public override copyFrom(ctx: TwoArgsFunctionTypeContext): void {
    super.copyFrom(ctx)
  }
}
export class LeftFunctionContext extends TwoArgsFunctionTypeContext {
  constructor(parser: formulaParser, ctx: TwoArgsFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public LEFT(): TerminalNode {
    return this.getToken(formulaParser.LEFT, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterLeftFunction) {
      listener.enterLeftFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitLeftFunction) {
      listener.exitLeftFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitLeftFunction) {
      return visitor.visitLeftFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class RightFunctionContext extends TwoArgsFunctionTypeContext {
  constructor(parser: formulaParser, ctx: TwoArgsFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public RIGHT(): TerminalNode {
    return this.getToken(formulaParser.RIGHT, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterRightFunction) {
      listener.enterRightFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitRightFunction) {
      listener.exitRightFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitRightFunction) {
      return visitor.visitRightFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ThreeArgsFunctionTypeContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_threeArgsFunctionType
  }
  public override copyFrom(ctx: ThreeArgsFunctionTypeContext): void {
    super.copyFrom(ctx)
  }
}
export class MidFunctionContext extends ThreeArgsFunctionTypeContext {
  constructor(parser: formulaParser, ctx: ThreeArgsFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public MID(): TerminalNode {
    return this.getToken(formulaParser.MID, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterMidFunction) {
      listener.enterMidFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitMidFunction) {
      listener.exitMidFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitMidFunction) {
      return visitor.visitMidFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class SubstituteFunctionContext extends ThreeArgsFunctionTypeContext {
  constructor(parser: formulaParser, ctx: ThreeArgsFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public SUBSTITUTE(): TerminalNode {
    return this.getToken(formulaParser.SUBSTITUTE, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterSubstituteFunction) {
      listener.enterSubstituteFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitSubstituteFunction) {
      listener.exitSubstituteFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitSubstituteFunction) {
      return visitor.visitSubstituteFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class DateaddFunctionContext extends ThreeArgsFunctionTypeContext {
  constructor(parser: formulaParser, ctx: ThreeArgsFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public DATEADD(): TerminalNode {
    return this.getToken(formulaParser.DATEADD, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterDateaddFunction) {
      listener.enterDateaddFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitDateaddFunction) {
      listener.exitDateaddFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitDateaddFunction) {
      return visitor.visitDateaddFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class DatediffFunctionContext extends ThreeArgsFunctionTypeContext {
  constructor(parser: formulaParser, ctx: ThreeArgsFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public DATEDIFF(): TerminalNode {
    return this.getToken(formulaParser.DATEDIFF, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterDatediffFunction) {
      listener.enterDatediffFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitDatediffFunction) {
      listener.exitDatediffFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitDatediffFunction) {
      return visitor.visitDatediffFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class DateFunctionContext extends ThreeArgsFunctionTypeContext {
  constructor(parser: formulaParser, ctx: ThreeArgsFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public DATE(): TerminalNode {
    return this.getToken(formulaParser.DATE, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterDateFunction) {
      listener.enterDateFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitDateFunction) {
      listener.exitDateFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitDateFunction) {
      return visitor.visitDateFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class IfFunctionTypeContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_ifFunctionType
  }
  public override copyFrom(ctx: IfFunctionTypeContext): void {
    super.copyFrom(ctx)
  }
}
export class MaxIfsFunctionContext extends IfFunctionTypeContext {
  constructor(parser: formulaParser, ctx: IfFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public MAXIFS(): TerminalNode {
    return this.getToken(formulaParser.MAXIFS, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterMaxIfsFunction) {
      listener.enterMaxIfsFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitMaxIfsFunction) {
      listener.exitMaxIfsFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitMaxIfsFunction) {
      return visitor.visitMaxIfsFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class AverageIfFunctionContext extends IfFunctionTypeContext {
  constructor(parser: formulaParser, ctx: IfFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public AVERAGEIF(): TerminalNode {
    return this.getToken(formulaParser.AVERAGEIF, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterAverageIfFunction) {
      listener.enterAverageIfFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitAverageIfFunction) {
      listener.exitAverageIfFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitAverageIfFunction) {
      return visitor.visitAverageIfFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class SumIfFunctionContext extends IfFunctionTypeContext {
  constructor(parser: formulaParser, ctx: IfFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public SUMIF(): TerminalNode {
    return this.getToken(formulaParser.SUMIF, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterSumIfFunction) {
      listener.enterSumIfFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitSumIfFunction) {
      listener.exitSumIfFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitSumIfFunction) {
      return visitor.visitSumIfFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class CountIfFunctionContext extends IfFunctionTypeContext {
  constructor(parser: formulaParser, ctx: IfFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public COUNTIF(): TerminalNode {
    return this.getToken(formulaParser.COUNTIF, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterCountIfFunction) {
      listener.enterCountIfFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitCountIfFunction) {
      listener.exitCountIfFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitCountIfFunction) {
      return visitor.visitCountIfFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class MinIfsFunctionContext extends IfFunctionTypeContext {
  constructor(parser: formulaParser, ctx: IfFunctionTypeContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public MINIFS(): TerminalNode {
    return this.getToken(formulaParser.MINIFS, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterMinIfsFunction) {
      listener.enterMinIfsFunction(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitMinIfsFunction) {
      listener.exitMinIfsFunction(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitMinIfsFunction) {
      return visitor.visitMinIfsFunction(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class LogicExprContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_logicExpr
  }
  public override copyFrom(ctx: LogicExprContext): void {
    super.copyFrom(ctx)
  }
}
export class SingleLogicExprContext extends LogicExprContext {
  constructor(parser: formulaParser, ctx: LogicExprContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public logicTerm(): LogicTermContext {
    return this.getTypedRuleContext(LogicTermContext, 0) as LogicTermContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterSingleLogicExpr) {
      listener.enterSingleLogicExpr(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitSingleLogicExpr) {
      listener.exitSingleLogicExpr(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitSingleLogicExpr) {
      return visitor.visitSingleLogicExpr(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class ParenthesizedLogicExprContext extends LogicExprContext {
  constructor(parser: formulaParser, ctx: LogicExprContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public LEFT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.LEFT_PAREN, 0)
  }
  public logicExpr(): LogicExprContext {
    return this.getTypedRuleContext(LogicExprContext, 0) as LogicExprContext
  }
  public RIGHT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.RIGHT_PAREN, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterParenthesizedLogicExpr) {
      listener.enterParenthesizedLogicExpr(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitParenthesizedLogicExpr) {
      listener.exitParenthesizedLogicExpr(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitParenthesizedLogicExpr) {
      return visitor.visitParenthesizedLogicExpr(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class OrChainedLogicExprContext extends LogicExprContext {
  constructor(parser: formulaParser, ctx: LogicExprContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public logicExpr_list(): LogicExprContext[] {
    return this.getTypedRuleContexts(LogicExprContext) as LogicExprContext[]
  }
  public logicExpr(i: number): LogicExprContext {
    return this.getTypedRuleContext(LogicExprContext, i) as LogicExprContext
  }
  public OR(): TerminalNode {
    return this.getToken(formulaParser.OR, 0)
  }
  public OR_OP(): TerminalNode {
    return this.getToken(formulaParser.OR_OP, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterOrChainedLogicExpr) {
      listener.enterOrChainedLogicExpr(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitOrChainedLogicExpr) {
      listener.exitOrChainedLogicExpr(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitOrChainedLogicExpr) {
      return visitor.visitOrChainedLogicExpr(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class AndChainedLogicExprContext extends LogicExprContext {
  constructor(parser: formulaParser, ctx: LogicExprContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public logicExpr_list(): LogicExprContext[] {
    return this.getTypedRuleContexts(LogicExprContext) as LogicExprContext[]
  }
  public logicExpr(i: number): LogicExprContext {
    return this.getTypedRuleContext(LogicExprContext, i) as LogicExprContext
  }
  public AND(): TerminalNode {
    return this.getToken(formulaParser.AND, 0)
  }
  public AND_OP(): TerminalNode {
    return this.getToken(formulaParser.AND_OP, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterAndChainedLogicExpr) {
      listener.enterAndChainedLogicExpr(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitAndChainedLogicExpr) {
      listener.exitAndChainedLogicExpr(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitAndChainedLogicExpr) {
      return visitor.visitAndChainedLogicExpr(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class LogicTermContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_logicTerm
  }
  public override copyFrom(ctx: LogicTermContext): void {
    super.copyFrom(ctx)
  }
}
export class InExpressionContext extends LogicTermContext {
  constructor(parser: formulaParser, ctx: LogicTermContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public inLogicExpr(): InLogicExprContext {
    return this.getTypedRuleContext(InLogicExprContext, 0) as InLogicExprContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterInExpression) {
      listener.enterInExpression(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitInExpression) {
      listener.exitInExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitInExpression) {
      return visitor.visitInExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class ParenthesizedLogicTermContext extends LogicTermContext {
  constructor(parser: formulaParser, ctx: LogicTermContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public LEFT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.LEFT_PAREN, 0)
  }
  public logicTerm(): LogicTermContext {
    return this.getTypedRuleContext(LogicTermContext, 0) as LogicTermContext
  }
  public RIGHT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.RIGHT_PAREN, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterParenthesizedLogicTerm) {
      listener.enterParenthesizedLogicTerm(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitParenthesizedLogicTerm) {
      listener.exitParenthesizedLogicTerm(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitParenthesizedLogicTerm) {
      return visitor.visitParenthesizedLogicTerm(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class ArrayRightContainsExpressionContext extends LogicTermContext {
  constructor(parser: formulaParser, ctx: LogicTermContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public arrayRightContainsLogicExpr(): ArrayRightContainsLogicExprContext {
    return this.getTypedRuleContext(
      ArrayRightContainsLogicExprContext,
      0,
    ) as ArrayRightContainsLogicExprContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterArrayRightContainsExpression) {
      listener.enterArrayRightContainsExpression(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitArrayRightContainsExpression) {
      listener.exitArrayRightContainsExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitArrayRightContainsExpression) {
      return visitor.visitArrayRightContainsExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class ScalarRightContainsExpressionContext extends LogicTermContext {
  constructor(parser: formulaParser, ctx: LogicTermContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public scalarRightContainsLogicExpr(): ScalarRightContainsLogicExprContext {
    return this.getTypedRuleContext(
      ScalarRightContainsLogicExprContext,
      0,
    ) as ScalarRightContainsLogicExprContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterScalarRightContainsExpression) {
      listener.enterScalarRightContainsExpression(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitScalarRightContainsExpression) {
      listener.exitScalarRightContainsExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitScalarRightContainsExpression) {
      return visitor.visitScalarRightContainsExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class NotExpressionContext extends LogicTermContext {
  constructor(parser: formulaParser, ctx: LogicTermContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public notLogicExpr(): NotLogicExprContext {
    return this.getTypedRuleContext(NotLogicExprContext, 0) as NotLogicExprContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterNotExpression) {
      listener.enterNotExpression(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitNotExpression) {
      listener.exitNotExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitNotExpression) {
      return visitor.visitNotExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class ComparisonExpressionContext extends LogicTermContext {
  constructor(parser: formulaParser, ctx: LogicTermContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public comparisonLogicExpr(): ComparisonLogicExprContext {
    return this.getTypedRuleContext(ComparisonLogicExprContext, 0) as ComparisonLogicExprContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterComparisonExpression) {
      listener.enterComparisonExpression(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitComparisonExpression) {
      listener.exitComparisonExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitComparisonExpression) {
      return visitor.visitComparisonExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class UnaryExpressionContext extends LogicTermContext {
  constructor(parser: formulaParser, ctx: LogicTermContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public unaryLogicExpr(): UnaryLogicExprContext {
    return this.getTypedRuleContext(UnaryLogicExprContext, 0) as UnaryLogicExprContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterUnaryExpression) {
      listener.enterUnaryExpression(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitUnaryExpression) {
      listener.exitUnaryExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitUnaryExpression) {
      return visitor.visitUnaryExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class BooleanExpressionContext extends LogicTermContext {
  constructor(parser: formulaParser, ctx: LogicTermContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public BOOLEAN(): TerminalNode {
    return this.getToken(formulaParser.BOOLEAN, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterBooleanExpression) {
      listener.enterBooleanExpression(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitBooleanExpression) {
      listener.exitBooleanExpression(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitBooleanExpression) {
      return visitor.visitBooleanExpression(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class NotLogicExprContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_notLogicExpr
  }
  public override copyFrom(ctx: NotLogicExprContext): void {
    super.copyFrom(ctx)
  }
}
export class NotExprContext extends NotLogicExprContext {
  constructor(parser: formulaParser, ctx: NotLogicExprContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public LEFT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.LEFT_PAREN, 0)
  }
  public logicExpr(): LogicExprContext {
    return this.getTypedRuleContext(LogicExprContext, 0) as LogicExprContext
  }
  public RIGHT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.RIGHT_PAREN, 0)
  }
  public NOT(): TerminalNode {
    return this.getToken(formulaParser.NOT, 0)
  }
  public NOT_OP(): TerminalNode {
    return this.getToken(formulaParser.NOT_OP, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterNotExpr) {
      listener.enterNotExpr(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitNotExpr) {
      listener.exitNotExpr(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitNotExpr) {
      return visitor.visitNotExpr(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ComparisonLogicExprContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_comparisonLogicExpr
  }
  public override copyFrom(ctx: ComparisonLogicExprContext): void {
    super.copyFrom(ctx)
  }
}
export class BinaryLogicExprContext extends ComparisonLogicExprContext {
  constructor(parser: formulaParser, ctx: ComparisonLogicExprContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public binarylogicOperator(): BinarylogicOperatorContext {
    return this.getTypedRuleContext(BinarylogicOperatorContext, 0) as BinarylogicOperatorContext
  }
  public logicValueList_list(): LogicValueListContext[] {
    return this.getTypedRuleContexts(LogicValueListContext) as LogicValueListContext[]
  }
  public logicValueList(i: number): LogicValueListContext {
    return this.getTypedRuleContext(LogicValueListContext, i) as LogicValueListContext
  }
  public logicExprValue_list(): LogicExprValueContext[] {
    return this.getTypedRuleContexts(LogicExprValueContext) as LogicExprValueContext[]
  }
  public logicExprValue(i: number): LogicExprValueContext {
    return this.getTypedRuleContext(LogicExprValueContext, i) as LogicExprValueContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterBinaryLogicExpr) {
      listener.enterBinaryLogicExpr(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitBinaryLogicExpr) {
      listener.exitBinaryLogicExpr(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitBinaryLogicExpr) {
      return visitor.visitBinaryLogicExpr(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ScalarRightContainsLogicExprContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_scalarRightContainsLogicExpr
  }
  public override copyFrom(ctx: ScalarRightContainsLogicExprContext): void {
    super.copyFrom(ctx)
  }
}
export class ScalarRightContainsExprContext extends ScalarRightContainsLogicExprContext {
  constructor(parser: formulaParser, ctx: ScalarRightContainsLogicExprContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public scalarRightContainsLogicOperator(): ScalarRightContainsLogicOperatorContext {
    return this.getTypedRuleContext(
      ScalarRightContainsLogicOperatorContext,
      0,
    ) as ScalarRightContainsLogicOperatorContext
  }
  public logicExprValue_list(): LogicExprValueContext[] {
    return this.getTypedRuleContexts(LogicExprValueContext) as LogicExprValueContext[]
  }
  public logicExprValue(i: number): LogicExprValueContext {
    return this.getTypedRuleContext(LogicExprValueContext, i) as LogicExprValueContext
  }
  public logicValueList(): LogicValueListContext {
    return this.getTypedRuleContext(LogicValueListContext, 0) as LogicValueListContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterScalarRightContainsExpr) {
      listener.enterScalarRightContainsExpr(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitScalarRightContainsExpr) {
      listener.exitScalarRightContainsExpr(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitScalarRightContainsExpr) {
      return visitor.visitScalarRightContainsExpr(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ArrayRightContainsLogicExprContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_arrayRightContainsLogicExpr
  }
  public override copyFrom(ctx: ArrayRightContainsLogicExprContext): void {
    super.copyFrom(ctx)
  }
}
export class ArrayRightContainsExprContext extends ArrayRightContainsLogicExprContext {
  constructor(parser: formulaParser, ctx: ArrayRightContainsLogicExprContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public arrayRightContainsLogicOperator(): ArrayRightContainsLogicOperatorContext {
    return this.getTypedRuleContext(
      ArrayRightContainsLogicOperatorContext,
      0,
    ) as ArrayRightContainsLogicOperatorContext
  }
  public logicValueList_list(): LogicValueListContext[] {
    return this.getTypedRuleContexts(LogicValueListContext) as LogicValueListContext[]
  }
  public logicValueList(i: number): LogicValueListContext {
    return this.getTypedRuleContext(LogicValueListContext, i) as LogicValueListContext
  }
  public logicExprValue_list(): LogicExprValueContext[] {
    return this.getTypedRuleContexts(LogicExprValueContext) as LogicExprValueContext[]
  }
  public logicExprValue(i: number): LogicExprValueContext {
    return this.getTypedRuleContext(LogicExprValueContext, i) as LogicExprValueContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterArrayRightContainsExpr) {
      listener.enterArrayRightContainsExpr(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitArrayRightContainsExpr) {
      listener.exitArrayRightContainsExpr(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitArrayRightContainsExpr) {
      return visitor.visitArrayRightContainsExpr(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class InLogicExprContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_inLogicExpr
  }
  public override copyFrom(ctx: InLogicExprContext): void {
    super.copyFrom(ctx)
  }
}
export class InExprContext extends InLogicExprContext {
  constructor(parser: formulaParser, ctx: InLogicExprContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public logicExprValue_list(): LogicExprValueContext[] {
    return this.getTypedRuleContexts(LogicExprValueContext) as LogicExprValueContext[]
  }
  public logicExprValue(i: number): LogicExprValueContext {
    return this.getTypedRuleContext(LogicExprValueContext, i) as LogicExprValueContext
  }
  public inLogicOperator(): InLogicOperatorContext {
    return this.getTypedRuleContext(InLogicOperatorContext, 0) as InLogicOperatorContext
  }
  public logicValueList(): LogicValueListContext {
    return this.getTypedRuleContext(LogicValueListContext, 0) as LogicValueListContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterInExpr) {
      listener.enterInExpr(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitInExpr) {
      listener.exitInExpr(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitInExpr) {
      return visitor.visitInExpr(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class UnaryLogicExprContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_unaryLogicExpr
  }
  public override copyFrom(ctx: UnaryLogicExprContext): void {
    super.copyFrom(ctx)
  }
}
export class UnaryExprContext extends UnaryLogicExprContext {
  constructor(parser: formulaParser, ctx: UnaryLogicExprContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public logicExprValue(): LogicExprValueContext {
    return this.getTypedRuleContext(LogicExprValueContext, 0) as LogicExprValueContext
  }
  public unaryLogicOperator(): UnaryLogicOperatorContext {
    return this.getTypedRuleContext(UnaryLogicOperatorContext, 0) as UnaryLogicOperatorContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterUnaryExpr) {
      listener.enterUnaryExpr(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitUnaryExpr) {
      listener.exitUnaryExpr(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitUnaryExpr) {
      return visitor.visitUnaryExpr(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class LogicExprValueContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_logicExprValue
  }
  public override copyFrom(ctx: LogicExprValueContext): void {
    super.copyFrom(ctx)
  }
}
export class DirectValueContext extends LogicExprValueContext {
  constructor(parser: formulaParser, ctx: LogicExprValueContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public logicValue(): LogicValueContext {
    return this.getTypedRuleContext(LogicValueContext, 0) as LogicValueContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterDirectValue) {
      listener.enterDirectValue(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitDirectValue) {
      listener.exitDirectValue(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitDirectValue) {
      return visitor.visitDirectValue(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class FormulaInLogicContext extends LogicExprValueContext {
  constructor(parser: formulaParser, ctx: LogicExprValueContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public formulaExpr(): FormulaExprContext {
    return this.getTypedRuleContext(FormulaExprContext, 0) as FormulaExprContext
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterFormulaInLogic) {
      listener.enterFormulaInLogic(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitFormulaInLogic) {
      listener.exitFormulaInLogic(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitFormulaInLogic) {
      return visitor.visitFormulaInLogic(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class LogicExprColumnRefContext extends LogicExprValueContext {
  constructor(parser: formulaParser, ctx: LogicExprValueContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public COLUMN_ID(): TerminalNode {
    return this.getToken(formulaParser.COLUMN_ID, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterLogicExprColumnRef) {
      listener.enterLogicExprColumnRef(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitLogicExprColumnRef) {
      listener.exitLogicExprColumnRef(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitLogicExprColumnRef) {
      return visitor.visitLogicExprColumnRef(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class BinarylogicOperatorContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_binarylogicOperator
  }
  public override copyFrom(ctx: BinarylogicOperatorContext): void {
    super.copyFrom(ctx)
  }
}
export class EqualContext extends BinarylogicOperatorContext {
  constructor(parser: formulaParser, ctx: BinarylogicOperatorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public EQ(): TerminalNode {
    return this.getToken(formulaParser.EQ, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterEqual) {
      listener.enterEqual(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitEqual) {
      listener.exitEqual(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitEqual) {
      return visitor.visitEqual(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class LessThanContext extends BinarylogicOperatorContext {
  constructor(parser: formulaParser, ctx: BinarylogicOperatorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public LT(): TerminalNode {
    return this.getToken(formulaParser.LT, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterLessThan) {
      listener.enterLessThan(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitLessThan) {
      listener.exitLessThan(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitLessThan) {
      return visitor.visitLessThan(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class LessThanOrEqualContext extends BinarylogicOperatorContext {
  constructor(parser: formulaParser, ctx: BinarylogicOperatorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public LTE(): TerminalNode {
    return this.getToken(formulaParser.LTE, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterLessThanOrEqual) {
      listener.enterLessThanOrEqual(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitLessThanOrEqual) {
      listener.exitLessThanOrEqual(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitLessThanOrEqual) {
      return visitor.visitLessThanOrEqual(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class NotEqualContext extends BinarylogicOperatorContext {
  constructor(parser: formulaParser, ctx: BinarylogicOperatorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public NOT_EQ(): TerminalNode {
    return this.getToken(formulaParser.NOT_EQ, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterNotEqual) {
      listener.enterNotEqual(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitNotEqual) {
      listener.exitNotEqual(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitNotEqual) {
      return visitor.visitNotEqual(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class GreaterThanContext extends BinarylogicOperatorContext {
  constructor(parser: formulaParser, ctx: BinarylogicOperatorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public GT(): TerminalNode {
    return this.getToken(formulaParser.GT, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterGreaterThan) {
      listener.enterGreaterThan(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitGreaterThan) {
      listener.exitGreaterThan(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitGreaterThan) {
      return visitor.visitGreaterThan(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class GreaterThanOrEqualContext extends BinarylogicOperatorContext {
  constructor(parser: formulaParser, ctx: BinarylogicOperatorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public GTE(): TerminalNode {
    return this.getToken(formulaParser.GTE, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterGreaterThanOrEqual) {
      listener.enterGreaterThanOrEqual(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitGreaterThanOrEqual) {
      listener.exitGreaterThanOrEqual(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitGreaterThanOrEqual) {
      return visitor.visitGreaterThanOrEqual(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ArrayRightContainsLogicOperatorContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_arrayRightContainsLogicOperator
  }
  public override copyFrom(ctx: ArrayRightContainsLogicOperatorContext): void {
    super.copyFrom(ctx)
  }
}
export class ContainsAllContext extends ArrayRightContainsLogicOperatorContext {
  constructor(parser: formulaParser, ctx: ArrayRightContainsLogicOperatorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public CONTAINS_ALL(): TerminalNode {
    return this.getToken(formulaParser.CONTAINS_ALL, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterContainsAll) {
      listener.enterContainsAll(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitContainsAll) {
      listener.exitContainsAll(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitContainsAll) {
      return visitor.visitContainsAll(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class ContainsAnyContext extends ArrayRightContainsLogicOperatorContext {
  constructor(parser: formulaParser, ctx: ArrayRightContainsLogicOperatorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public CONTAINS_ANY(): TerminalNode {
    return this.getToken(formulaParser.CONTAINS_ANY, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterContainsAny) {
      listener.enterContainsAny(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitContainsAny) {
      listener.exitContainsAny(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitContainsAny) {
      return visitor.visitContainsAny(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class DoesNotContainAnyContext extends ArrayRightContainsLogicOperatorContext {
  constructor(parser: formulaParser, ctx: ArrayRightContainsLogicOperatorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public DOES_NOT_CONTAIN_ANY(): TerminalNode {
    return this.getToken(formulaParser.DOES_NOT_CONTAIN_ANY, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterDoesNotContainAny) {
      listener.enterDoesNotContainAny(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitDoesNotContainAny) {
      listener.exitDoesNotContainAny(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitDoesNotContainAny) {
      return visitor.visitDoesNotContainAny(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class ScalarRightContainsLogicOperatorContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_scalarRightContainsLogicOperator
  }
  public override copyFrom(ctx: ScalarRightContainsLogicOperatorContext): void {
    super.copyFrom(ctx)
  }
}
export class ContainsContext extends ScalarRightContainsLogicOperatorContext {
  constructor(parser: formulaParser, ctx: ScalarRightContainsLogicOperatorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public CONTAINS(): TerminalNode {
    return this.getToken(formulaParser.CONTAINS, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterContains) {
      listener.enterContains(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitContains) {
      listener.exitContains(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitContains) {
      return visitor.visitContains(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class DoesNotContainContext extends ScalarRightContainsLogicOperatorContext {
  constructor(parser: formulaParser, ctx: ScalarRightContainsLogicOperatorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public DOES_NOT_CONTAIN(): TerminalNode {
    return this.getToken(formulaParser.DOES_NOT_CONTAIN, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterDoesNotContain) {
      listener.enterDoesNotContain(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitDoesNotContain) {
      listener.exitDoesNotContain(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitDoesNotContain) {
      return visitor.visitDoesNotContain(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class InLogicOperatorContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_inLogicOperator
  }
  public override copyFrom(ctx: InLogicOperatorContext): void {
    super.copyFrom(ctx)
  }
}
export class InContext extends InLogicOperatorContext {
  constructor(parser: formulaParser, ctx: InLogicOperatorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public IN(): TerminalNode {
    return this.getToken(formulaParser.IN, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterIn) {
      listener.enterIn(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitIn) {
      listener.exitIn(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitIn) {
      return visitor.visitIn(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class NotInContext extends InLogicOperatorContext {
  constructor(parser: formulaParser, ctx: InLogicOperatorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public NOT_IN(): TerminalNode {
    return this.getToken(formulaParser.NOT_IN, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterNotIn) {
      listener.enterNotIn(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitNotIn) {
      listener.exitNotIn(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitNotIn) {
      return visitor.visitNotIn(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class UnaryLogicOperatorContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_unaryLogicOperator
  }
  public override copyFrom(ctx: UnaryLogicOperatorContext): void {
    super.copyFrom(ctx)
  }
}
export class IsEmptyContext extends UnaryLogicOperatorContext {
  constructor(parser: formulaParser, ctx: UnaryLogicOperatorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public IS_EMPTY(): TerminalNode {
    return this.getToken(formulaParser.IS_EMPTY, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterIsEmpty) {
      listener.enterIsEmpty(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitIsEmpty) {
      listener.exitIsEmpty(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitIsEmpty) {
      return visitor.visitIsEmpty(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class IsNotEmptyContext extends UnaryLogicOperatorContext {
  constructor(parser: formulaParser, ctx: UnaryLogicOperatorContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public IS_NOT_EMPTY(): TerminalNode {
    return this.getToken(formulaParser.IS_NOT_EMPTY, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterIsNotEmpty) {
      listener.enterIsNotEmpty(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitIsNotEmpty) {
      listener.exitIsNotEmpty(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitIsNotEmpty) {
      return visitor.visitIsNotEmpty(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class LogicValueContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_logicValue
  }
  public override copyFrom(ctx: LogicValueContext): void {
    super.copyFrom(ctx)
  }
}
export class StringValueContext extends LogicValueContext {
  constructor(parser: formulaParser, ctx: LogicValueContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public STRING(): TerminalNode {
    return this.getToken(formulaParser.STRING, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterStringValue) {
      listener.enterStringValue(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitStringValue) {
      listener.exitStringValue(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitStringValue) {
      return visitor.visitStringValue(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class NegativeNumericValueContext extends LogicValueContext {
  constructor(parser: formulaParser, ctx: LogicValueContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public MINUS(): TerminalNode {
    return this.getToken(formulaParser.MINUS, 0)
  }
  public NUMBER(): TerminalNode {
    return this.getToken(formulaParser.NUMBER, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterNegativeNumericValue) {
      listener.enterNegativeNumericValue(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitNegativeNumericValue) {
      listener.exitNegativeNumericValue(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitNegativeNumericValue) {
      return visitor.visitNegativeNumericValue(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class NumericValueContext extends LogicValueContext {
  constructor(parser: formulaParser, ctx: LogicValueContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public NUMBER(): TerminalNode {
    return this.getToken(formulaParser.NUMBER, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterNumericValue) {
      listener.enterNumericValue(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitNumericValue) {
      listener.exitNumericValue(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitNumericValue) {
      return visitor.visitNumericValue(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class BooleanValueContext extends LogicValueContext {
  constructor(parser: formulaParser, ctx: LogicValueContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public BOOLEAN(): TerminalNode {
    return this.getToken(formulaParser.BOOLEAN, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterBooleanValue) {
      listener.enterBooleanValue(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitBooleanValue) {
      listener.exitBooleanValue(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitBooleanValue) {
      return visitor.visitBooleanValue(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class LogicValueListContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_logicValueList
  }
  public override copyFrom(ctx: LogicValueListContext): void {
    super.copyFrom(ctx)
  }
}
export class NumericValueListContext extends LogicValueListContext {
  constructor(parser: formulaParser, ctx: LogicValueListContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public LEFT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.LEFT_PAREN, 0)
  }
  public RIGHT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.RIGHT_PAREN, 0)
  }
  public numericListItem_list(): NumericListItemContext[] {
    return this.getTypedRuleContexts(NumericListItemContext) as NumericListItemContext[]
  }
  public numericListItem(i: number): NumericListItemContext {
    return this.getTypedRuleContext(NumericListItemContext, i) as NumericListItemContext
  }
  public negativeNumericListItem_list(): NegativeNumericListItemContext[] {
    return this.getTypedRuleContexts(
      NegativeNumericListItemContext,
    ) as NegativeNumericListItemContext[]
  }
  public negativeNumericListItem(i: number): NegativeNumericListItemContext {
    return this.getTypedRuleContext(
      NegativeNumericListItemContext,
      i,
    ) as NegativeNumericListItemContext
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(formulaParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(formulaParser.COMMA, i)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterNumericValueList) {
      listener.enterNumericValueList(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitNumericValueList) {
      listener.exitNumericValueList(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitNumericValueList) {
      return visitor.visitNumericValueList(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
export class StringValueListContext extends LogicValueListContext {
  constructor(parser: formulaParser, ctx: LogicValueListContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public LEFT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.LEFT_PAREN, 0)
  }
  public stringListItem_list(): StringListItemContext[] {
    return this.getTypedRuleContexts(StringListItemContext) as StringListItemContext[]
  }
  public stringListItem(i: number): StringListItemContext {
    return this.getTypedRuleContext(StringListItemContext, i) as StringListItemContext
  }
  public RIGHT_PAREN(): TerminalNode {
    return this.getToken(formulaParser.RIGHT_PAREN, 0)
  }
  public COMMA_list(): TerminalNode[] {
    return this.getTokens(formulaParser.COMMA)
  }
  public COMMA(i: number): TerminalNode {
    return this.getToken(formulaParser.COMMA, i)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterStringValueList) {
      listener.enterStringValueList(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitStringValueList) {
      listener.exitStringValueList(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitStringValueList) {
      return visitor.visitStringValueList(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class NumericListItemContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_numericListItem
  }
  public override copyFrom(ctx: NumericListItemContext): void {
    super.copyFrom(ctx)
  }
}
export class NumericItemContext extends NumericListItemContext {
  constructor(parser: formulaParser, ctx: NumericListItemContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public NUMBER(): TerminalNode {
    return this.getToken(formulaParser.NUMBER, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterNumericItem) {
      listener.enterNumericItem(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitNumericItem) {
      listener.exitNumericItem(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitNumericItem) {
      return visitor.visitNumericItem(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class NegativeNumericListItemContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_negativeNumericListItem
  }
  public override copyFrom(ctx: NegativeNumericListItemContext): void {
    super.copyFrom(ctx)
  }
}
export class NegativeNumericItemContext extends NegativeNumericListItemContext {
  constructor(parser: formulaParser, ctx: NegativeNumericListItemContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public MINUS(): TerminalNode {
    return this.getToken(formulaParser.MINUS, 0)
  }
  public NUMBER(): TerminalNode {
    return this.getToken(formulaParser.NUMBER, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterNegativeNumericItem) {
      listener.enterNegativeNumericItem(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitNegativeNumericItem) {
      listener.exitNegativeNumericItem(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitNegativeNumericItem) {
      return visitor.visitNegativeNumericItem(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}

export class StringListItemContext extends ParserRuleContext {
  constructor(parser?: formulaParser, parent?: ParserRuleContext, invokingState?: number) {
    super(parent, invokingState)
    this.parser = parser
  }
  public get ruleIndex(): number {
    return formulaParser.RULE_stringListItem
  }
  public override copyFrom(ctx: StringListItemContext): void {
    super.copyFrom(ctx)
  }
}
export class StringItemContext extends StringListItemContext {
  constructor(parser: formulaParser, ctx: StringListItemContext) {
    super(parser, ctx.parentCtx, ctx.invokingState)
    super.copyFrom(ctx)
  }
  public STRING(): TerminalNode {
    return this.getToken(formulaParser.STRING, 0)
  }
  public enterRule(listener: formulaListener): void {
    if (listener.enterStringItem) {
      listener.enterStringItem(this)
    }
  }
  public exitRule(listener: formulaListener): void {
    if (listener.exitStringItem) {
      listener.exitStringItem(this)
    }
  }
  // @Override
  public accept<Result>(visitor: formulaVisitor<Result>): Result {
    if (visitor.visitStringItem) {
      return visitor.visitStringItem(this)
    } else {
      return visitor.visitChildren(this)
    }
  }
}
